import { OptionType } from './NewTradeList';
const TradeListOptions: OptionType[] = [
  {
    label: 'Access Control',
    value: 'Access Control',
    trade: {
      trade: 'Access Control',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Access Control and Intrusion Detection',
    value: 'Access Control and Intrusion Detection',
    trade: {
      trade: 'Access Control and Intrusion Detection',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Access Flooring',
    value: 'Access Flooring',
    trade: {
      trade: 'Access Flooring',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Accessories',
    value: 'Accessories',
    trade: { trade: 'Accessories', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Acoustical Ceiling Treatment',
    value: 'Acoustical Ceiling Treatment',
    trade: {
      trade: 'Acoustical Ceiling Treatment',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Acoustical Suspended Ceilings',
    value: 'Acoustical Suspended Ceilings',
    trade: {
      trade: 'Acoustical Suspended Ceilings',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Acoustical Wall Treatment',
    value: 'Acoustical Wall Treatment',
    trade: {
      trade: 'Acoustical Wall Treatment',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Agricultural Equipment',
    value: 'Agricultural Equipment',
    trade: {
      trade: 'Agricultural Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Air-to-Air Energy Recovery',
    value: 'Air-to-Air Energy Recovery',
    trade: {
      trade: 'Air-to-Air Energy Recovery',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Airfield Lighting',
    value: 'Airfield Lighting',
    trade: { trade: 'Airfield Lighting', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Airfield Signaling and Control Equipment',
    value: 'Airfield Signaling and Control Equipment',
    trade: {
      trade: 'Airfield Signaling and Control Equipment',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Airfields',
    value: 'Airfields',
    trade: { trade: 'Airfields', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Amusement Park Structures and Equipment',
    value: 'Amusement Park Structures and Equipment',
    trade: {
      trade: 'Amusement Park Structures and Equipment',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Anchor Tiebacks',
    value: 'Anchor Tiebacks',
    trade: {
      trade: 'Anchor Tiebacks',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Animal Containment',
    value: 'Animal Containment',
    trade: {
      trade: 'Animal Containment',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Appliance Supplier',
    value: 'Appliance Supplier',
    trade: { trade: 'Appliance Supplier', category: 'Supplier', sortOrder: 0 }
  },
  {
    label: 'Aquariums',
    value: 'Aquariums',
    trade: { trade: 'Aquariums', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Area Lighting',
    value: 'Area Lighting',
    trade: { trade: 'Area Lighting', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Arena Football Boards',
    value: 'Arena Football Boards',
    trade: {
      trade: 'Arena Football Boards',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Asbestos Remediation',
    value: 'Asbestos Remediation',
    trade: {
      trade: 'Asbestos Remediation',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Athletic Areas',
    value: 'Athletic Areas',
    trade: { trade: 'Athletic Areas', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Athletic Equipment',
    value: 'Athletic Equipment',
    trade: { trade: 'Athletic Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Athletic Flooring',
    value: 'Athletic Flooring',
    trade: {
      trade: 'Athletic Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Athletic and Recreational Court Walls',
    value: 'Athletic and Recreational Court Walls',
    trade: {
      trade: 'Athletic and Recreational Court Walls',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Athletic and Recreational Special Construction',
    value: 'Athletic and Recreational Special Construction',
    trade: {
      trade: 'Athletic and Recreational Special Construction',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Athletic, Recreational, and Playfield Areas',
    value: 'Athletic, Recreational, and Playfield Areas',
    trade: {
      trade: 'Athletic, Recreational, and Playfield Areas',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Audio-Video Communication',
    value: 'Audio-Video Communication',
    trade: {
      trade: 'Audio-Video Communication',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Audio-Video Systems',
    value: 'Audio-Video Systems',
    trade: {
      trade: 'Audio-Video Systems',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Aviation Pavement',
    value: 'Aviation Pavement',
    trade: { trade: 'Aviation Pavement', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Aviation Pavement Appurtenances',
    value: 'Aviation Pavement Appurtenances',
    trade: {
      trade: 'Aviation Pavement Appurtenances',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Aviation Pavement Curbs and Gutters',
    value: 'Aviation Pavement Curbs and Gutters',
    trade: {
      trade: 'Aviation Pavement Curbs and Gutters',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Backfill and Compaction',
    value: 'Backfill and Compaction',
    trade: {
      trade: 'Backfill and Compaction',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Baggage Handling Equipment',
    value: 'Baggage Handling Equipment',
    trade: {
      trade: 'Baggage Handling Equipment',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Balcony Floor Construction',
    value: 'Balcony Floor Construction',
    trade: {
      trade: 'Balcony Floor Construction',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Battery Equipment',
    value: 'Battery Equipment',
    trade: { trade: 'Battery Equipment', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Biological Decontamination',
    value: 'Biological Decontamination',
    trade: {
      trade: 'Biological Decontamination',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Bird Control Devices',
    value: 'Bird Control Devices',
    trade: {
      trade: 'Bird Control Devices',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Boilermaker',
    value: 'Boilermaker',
    trade: { trade: 'Boilermaker', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Bored Piles',
    value: 'Bored Piles',
    trade: {
      trade: 'Bored Piles',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Branch Wiring System',
    value: 'Branch Wiring System',
    trade: { trade: 'Branch Wiring System', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Branch Wiring for Lighting',
    value: 'Branch Wiring for Lighting',
    trade: {
      trade: 'Branch Wiring for Lighting',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Breathing Air Replenishment Systems',
    value: 'Breathing Air Replenishment Systems',
    trade: {
      trade: 'Breathing Air Replenishment Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Brick Siding',
    value: 'Brick Siding',
    trade: { trade: 'Brick Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Bridge Demolition',
    value: 'Bridge Demolition',
    trade: { trade: 'Bridge Demolition', category: 'Demolition', sortOrder: 0 }
  },
  {
    label: 'Building Cleaning',
    value: 'Building Cleaning',
    trade: { trade: 'Building Cleaning', category: 'Cleaning', sortOrder: 0 }
  },
  {
    label: 'Building Demolition',
    value: 'Building Demolition',
    trade: {
      trade: 'Building Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Building Envelope Access',
    value: 'Building Envelope Access',
    trade: {
      trade: 'Building Envelope Access',
      category: 'Scaffolding',
      sortOrder: 0
    }
  },
  {
    label: 'Building Illumination',
    value: 'Building Illumination',
    trade: {
      trade: 'Building Illumination',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Building Modules',
    value: 'Building Modules',
    trade: {
      trade: 'Building Modules',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Building Product Manufacturing and Supply',
    value: 'Building Product Manufacturing and Supply',
    trade: {
      trade: 'Building Product Manufacturing and Supply',
      category: 'Supplier',
      sortOrder: 0
    }
  },
  {
    label: 'Building Subdrainage',
    value: 'Building Subdrainage',
    trade: {
      trade: 'Building Subdrainage',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Building Support Plumbing System Supplementary Components',
    value: 'Building Support Plumbing System Supplementary Components',
    trade: {
      trade: 'Building Support Plumbing System Supplementary Components',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Building Support Plumbing Systems',
    value: 'Building Support Plumbing Systems',
    trade: {
      trade: 'Building Support Plumbing Systems',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Cabinet Maker',
    value: 'Cabinet Maker',
    trade: {
      trade: 'Cabinet Maker',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Caissons',
    value: 'Caissons',
    trade: {
      trade: 'Caissons',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Call Accounting',
    value: 'Call Accounting',
    trade: {
      trade: 'Call Accounting',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Call Management',
    value: 'Call Management',
    trade: {
      trade: 'Call Management',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Canopy Construction',
    value: 'Canopy Construction',
    trade: { trade: 'Canopy Construction', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Canopy Roofing',
    value: 'Canopy Roofing',
    trade: { trade: 'Canopy Roofing', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Carpet and Upholstery Cleaning',
    value: 'Carpet and Upholstery Cleaning',
    trade: {
      trade: 'Carpet and Upholstery Cleaning',
      category: 'Cleaning',
      sortOrder: 0
    }
  },
  {
    label: 'Carpeted Stair Finish',
    value: 'Carpeted Stair Finish',
    trade: {
      trade: 'Carpeted Stair Finish',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Carpeting',
    value: 'Carpeting',
    trade: { trade: 'Carpeting', category: 'Floors Stairs', sortOrder: 0 }
  },
  {
    label: 'Casework',
    value: 'Casework',
    trade: { trade: 'Casework', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Cathodic Protection',
    value: 'Cathodic Protection',
    trade: { trade: 'Cathodic Protection', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Ceiling Finish Supplementary Components',
    value: 'Ceiling Finish Supplementary Components',
    trade: {
      trade: 'Ceiling Finish Supplementary Components',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Ceiling Finishes',
    value: 'Ceiling Finishes',
    trade: { trade: 'Ceiling Finishes', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Ceiling Painting and Coating',
    value: 'Ceiling Painting and Coating',
    trade: {
      trade: 'Ceiling Painting and Coating',
      category: 'Paint',
      sortOrder: 0
    }
  },
  {
    label: 'Ceiling Paneling',
    value: 'Ceiling Paneling',
    trade: { trade: 'Ceiling Paneling', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Ceiling Suspension Components',
    value: 'Ceiling Suspension Components',
    trade: {
      trade: 'Ceiling Suspension Components',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Central Cooling',
    value: 'Central Cooling',
    trade: { trade: 'Central Cooling', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Chemical Decontamination',
    value: 'Chemical Decontamination',
    trade: {
      trade: 'Chemical Decontamination',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Chemical-Waste Systems',
    value: 'Chemical-Waste Systems',
    trade: {
      trade: 'Chemical-Waste Systems',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Chutes',
    value: 'Chutes',
    trade: {
      trade: 'Chutes',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Cladding',
    value: 'Cladding',
    trade: { trade: 'Cladding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Cleaning',
    value: 'Cleaning',
    trade: { trade: 'Cleaning', category: 'Cleaning', sortOrder: 0 }
  },
  {
    label: 'Clearing and Grubbing',
    value: 'Clearing and Grubbing',
    trade: {
      trade: 'Clearing and Grubbing',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Cofferdams',
    value: 'Cofferdams',
    trade: {
      trade: 'Cofferdams',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Column Foundations',
    value: 'Column Foundations',
    trade: {
      trade: 'Column Foundations',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Commercial Equipment',
    value: 'Commercial Equipment',
    trade: {
      trade: 'Commercial Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Commercial Laundry and Dry Cleaning Equipment',
    value: 'Commercial Laundry and Dry Cleaning Equipment',
    trade: {
      trade: 'Commercial Laundry and Dry Cleaning Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Communications',
    value: 'Communications',
    trade: { trade: 'Communications', category: 'Communications', sortOrder: 0 }
  },
  {
    label: 'Communications Supplementary Components',
    value: 'Communications Supplementary Components',
    trade: {
      trade: 'Communications Supplementary Components',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Compartments and Cubicles',
    value: 'Compartments and Cubicles',
    trade: {
      trade: 'Compartments and Cubicles',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Compressed-Air Systems',
    value: 'Compressed-Air Systems',
    trade: {
      trade: 'Compressed-Air Systems',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Concrete Cement Finishing Contracting',
    value: 'Concrete Cement Finishing Contracting',
    trade: {
      trade: 'Concrete Cement Finishing Contracting',
      category: 'Masonry',
      sortOrder: 0
    }
  },
  {
    label: 'Concrete Contracting',
    value: 'Concrete Contracting',
    trade: { trade: 'Concrete Contracting', category: 'Masonry', sortOrder: 0 }
  },
  {
    label: 'Concrete Flatwork',
    value: 'Concrete Flatwork',
    trade: { trade: 'Concrete Flatwork', category: 'Masonry', sortOrder: 0 }
  },
  {
    label: 'Concrete Restoration',
    value: 'Concrete Restoration',
    trade: {
      trade: 'Concrete Restoration',
      category: 'Restoration',
      sortOrder: 0
    }
  },
  {
    label: 'Construction Dewatering',
    value: 'Construction Dewatering',
    trade: {
      trade: 'Construction Dewatering',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Construction Equipment Manufacturing and Supply',
    value: 'Construction Equipment Manufacturing and Supply',
    trade: {
      trade: 'Construction Equipment Manufacturing and Supply',
      category: 'Supplier',
      sortOrder: 0
    }
  },
  {
    label: 'Construction Labor Equipment Operation',
    value: 'Construction Labor Equipment Operation',
    trade: {
      trade: 'Construction Labor Equipment Operation',
      category: 'Labor',
      sortOrder: 0
    }
  },
  {
    label: 'Contaminated Site Material Removal',
    value: 'Contaminated Site Material Removal',
    trade: {
      trade: 'Contaminated Site Material Removal',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Control and Communication Service',
    value: 'Control and Communication Service',
    trade: {
      trade: 'Control and Communication Service',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Conveying',
    value: 'Conveying',
    trade: { trade: 'Conveying', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Conveyors',
    value: 'Conveyors',
    trade: {
      trade: 'Conveyors',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Cooling System Supplementary Components',
    value: 'Cooling System Supplementary Components',
    trade: {
      trade: 'Cooling System Supplementary Components',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Cooling Systems',
    value: 'Cooling Systems',
    trade: { trade: 'Cooling Systems', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Covers and Shelters',
    value: 'Covers and Shelters',
    trade: { trade: 'Covers and Shelters', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Cranes',
    value: 'Cranes',
    trade: {
      trade: 'Cranes',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Cribbing and Walers',
    value: 'Cribbing and Walers',
    trade: {
      trade: 'Cribbing and Walers',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Culverts',
    value: 'Culverts',
    trade: { trade: 'Culverts', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Dam Demolition',
    value: 'Dam Demolition',
    trade: { trade: 'Dam Demolition', category: 'Demolition', sortOrder: 0 }
  },
  {
    label: 'Data Communication Program and Integration Services',
    value: 'Data Communication Program and Integration Services',
    trade: {
      trade: 'Data Communication Program and Integration Services',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Data Communications',
    value: 'Data Communications',
    trade: {
      trade: 'Data Communications',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Data Communications Hardware',
    value: 'Data Communications Hardware',
    trade: {
      trade: 'Data Communications Hardware',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Data Communications Network Equipment',
    value: 'Data Communications Network Equipment',
    trade: {
      trade: 'Data Communications Network Equipment',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Data Communications Peripheral Data Equipment',
    value: 'Data Communications Peripheral Data Equipment',
    trade: {
      trade: 'Data Communications Peripheral Data Equipment',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Data Communications Software',
    value: 'Data Communications Software',
    trade: {
      trade: 'Data Communications Software',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Decentralized Cooling',
    value: 'Decentralized Cooling',
    trade: { trade: 'Decentralized Cooling', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Decentralized Heating Equipment',
    value: 'Decentralized Heating Equipment',
    trade: {
      trade: 'Decentralized Heating Equipment',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Decontamination Equipment',
    value: 'Decontamination Equipment',
    trade: {
      trade: 'Decontamination Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Demolition',
    value: 'Demolition',
    trade: { trade: 'Demolition', category: 'Demolition', sortOrder: 0 }
  },
  {
    label: 'Demolition',
    value: 'Demolition',
    trade: { trade: 'Demolition', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Demountable Athletic Surfaces',
    value: 'Demountable Athletic Surfaces',
    trade: {
      trade: 'Demountable Athletic Surfaces',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Derricks',
    value: 'Derricks',
    trade: {
      trade: 'Derricks',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Detection and Alarm',
    value: 'Detection and Alarm',
    trade: {
      trade: 'Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Detention Equipment',
    value: 'Detention Equipment',
    trade: { trade: 'Detention Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Distributed Audio-Video Communications Systems',
    value: 'Distributed Audio-Video Communications Systems',
    trade: {
      trade: 'Distributed Audio-Video Communications Systems',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Distributed Communications and Monitoring',
    value: 'Distributed Communications and Monitoring',
    trade: {
      trade: 'Distributed Communications and Monitoring',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Distributed Systems',
    value: 'Distributed Systems',
    trade: {
      trade: 'Distributed Systems',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Domestic Water Distribution',
    value: 'Domestic Water Distribution',
    trade: {
      trade: 'Domestic Water Distribution',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Domestic Water Distribution Supplementary Components',
    value: 'Domestic Water Distribution Supplementary Components',
    trade: {
      trade: 'Domestic Water Distribution Supplementary Components',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Domestic Water Equipment',
    value: 'Domestic Water Equipment',
    trade: {
      trade: 'Domestic Water Equipment',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Domestic Water Piping',
    value: 'Domestic Water Piping',
    trade: {
      trade: 'Domestic Water Piping',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Doors',
    value: 'Doors',
    trade: { trade: 'Doors', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Dredge, Excavating, and Loading Machine Operation',
    value: 'Dredge, Excavating, and Loading Machine Operation',
    trade: {
      trade: 'Dredge, Excavating, and Loading Machine Operation',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Driven Piles',
    value: 'Driven Piles',
    trade: {
      trade: 'Driven Piles',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Dumbwaiters',
    value: 'Dumbwaiters',
    trade: { trade: 'Dumbwaiters', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Dumpster Contractor',
    value: 'Dumpster Contractor',
    trade: { trade: 'Dumpster Contractor', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Earth Dams',
    value: 'Earth Dams',
    trade: { trade: 'Earth Dams', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Earth Movement Monitoring',
    value: 'Earth Movement Monitoring',
    trade: {
      trade: 'Earth Movement Monitoring',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Earth Stripping and Stockpiling',
    value: 'Earth Stripping and Stockpiling',
    trade: {
      trade: 'Earth Stripping and Stockpiling',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Educational and Scientific Equipment',
    value: 'Educational and Scientific Equipment',
    trade: {
      trade: 'Educational and Scientific Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Electric Transmission and Distribution',
    value: 'Electric Transmission and Distribution',
    trade: {
      trade: 'Electric Transmission and Distribution',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electric Utility',
    value: 'Electric Utility',
    trade: { trade: 'Electric Utility', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Electrical',
    value: 'Electrical',
    trade: { trade: 'Electrical', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Electrical - Low Voltage',
    value: 'Electrical - Low Voltage',
    trade: {
      trade: 'Electrical - Low Voltage',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Contracting',
    value: 'Electrical Contracting',
    trade: {
      trade: 'Electrical Contracting',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Distribution System Instrumentation and Controls',
    value: 'Electrical Distribution System Instrumentation and Controls',
    trade: {
      trade: 'Electrical Distribution System Instrumentation and Controls',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Rough In',
    value: 'Electrical Rough In',
    trade: { trade: 'Electrical Rough In', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Electrical Service',
    value: 'Electrical Service',
    trade: { trade: 'Electrical Service', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Electrical Service and Distribution',
    value: 'Electrical Service and Distribution',
    trade: {
      trade: 'Electrical Service and Distribution',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Service and Distribution Supplementary Components',
    value: 'Electrical Service and Distribution Supplementary Components',
    trade: {
      trade: 'Electrical Service and Distribution Supplementary Components',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Site Improvements',
    value: 'Electrical Site Improvements',
    trade: {
      trade: 'Electrical Site Improvements',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Substations',
    value: 'Electrical Substations',
    trade: {
      trade: 'Electrical Substations',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Switchgear and Protection Devices',
    value: 'Electrical Switchgear and Protection Devices',
    trade: {
      trade: 'Electrical Switchgear and Protection Devices',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Transformers',
    value: 'Electrical Transformers',
    trade: {
      trade: 'Electrical Transformers',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Utility Services',
    value: 'Electrical Utility Services',
    trade: {
      trade: 'Electrical Utility Services',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Electrical Utility Services',
    value: 'Electrical Utility Services',
    trade: {
      trade: 'Electrical Utility Services',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Detention Monitoring and Control',
    value: 'Electronic Detention Monitoring and Control',
    trade: {
      trade: 'Electronic Detention Monitoring and Control',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Digital Systems',
    value: 'Electronic Digital Systems',
    trade: {
      trade: 'Electronic Digital Systems',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Monitoring and Control',
    value: 'Electronic Monitoring and Control',
    trade: {
      trade: 'Electronic Monitoring and Control',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Personal Protection',
    value: 'Electronic Personal Protection',
    trade: {
      trade: 'Electronic Personal Protection',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Safety and Security',
    value: 'Electronic Safety and Security',
    trade: {
      trade: 'Electronic Safety and Security',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Safety and Security Supplementary Components',
    value: 'Electronic Safety and Security Supplementary Components',
    trade: {
      trade: 'Electronic Safety and Security Supplementary Components',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Electronic Surveillance',
    value: 'Electronic Surveillance',
    trade: {
      trade: 'Electronic Surveillance',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Elevating Platforms',
    value: 'Elevating Platforms',
    trade: {
      trade: 'Elevating Platforms',
      category: 'Scaffolding',
      sortOrder: 0
    }
  },
  {
    label: 'Elevators',
    value: 'Elevators',
    trade: { trade: 'Elevators', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Embankments',
    value: 'Embankments',
    trade: { trade: 'Embankments', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Energy (Utility) Service Contracting',
    value: 'Energy (Utility) Service Contracting',
    trade: {
      trade: 'Energy (Utility) Service Contracting',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Engineered Wood Siding',
    value: 'Engineered Wood Siding',
    trade: { trade: 'Engineered Wood Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Entertainment and Recreational Equipment',
    value: 'Entertainment and Recreational Equipment',
    trade: {
      trade: 'Entertainment and Recreational Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Entrance Flooring',
    value: 'Entrance Flooring',
    trade: {
      trade: 'Entrance Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Environmental Energy Service',
    value: 'Environmental Energy Service',
    trade: {
      trade: 'Environmental Energy Service',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Equipment',
    value: 'Equipment',
    trade: { trade: 'Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Equipment Screens',
    value: 'Equipment Screens',
    trade: { trade: 'Equipment Screens', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Equipment and Furnishings',
    value: 'Equipment and Furnishings',
    trade: {
      trade: 'Equipment and Furnishings',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Erosion & Stormwater Contractor',
    value: 'Erosion & Stormwater Contractor',
    trade: {
      trade: 'Erosion & Stormwater Contractor',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Erosion and Sedimentation Controls',
    value: 'Erosion and Sedimentation Controls',
    trade: {
      trade: 'Erosion and Sedimentation Controls',
      category: 'Earthwork',
      sortOrder: 0
    }
  },
  {
    label: 'Escalators',
    value: 'Escalators',
    trade: { trade: 'Escalators', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Evaporative Air-Cooling',
    value: 'Evaporative Air-Cooling',
    trade: { trade: 'Evaporative Air-Cooling', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Excavation Support',
    value: 'Excavation Support',
    trade: {
      trade: 'Excavation Support',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Excavation and Fill',
    value: 'Excavation and Fill',
    trade: { trade: 'Excavation and Fill', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Exhaust Air',
    value: 'Exhaust Air',
    trade: { trade: 'Exhaust Air', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Exterior Balcony Walls and Railings',
    value: 'Exterior Balcony Walls and Railings',
    trade: {
      trade: 'Exterior Balcony Walls and Railings',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Bulkheads',
    value: 'Exterior Bulkheads',
    trade: { trade: 'Exterior Bulkheads', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Exterior Ceilings',
    value: 'Exterior Ceilings',
    trade: { trade: 'Exterior Ceilings', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Exterior Door Supplementary Components',
    value: 'Exterior Door Supplementary Components',
    trade: {
      trade: 'Exterior Door Supplementary Components',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Doors and Grilles',
    value: 'Exterior Doors and Grilles',
    trade: {
      trade: 'Exterior Doors and Grilles',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Entrance Doors',
    value: 'Exterior Entrance Doors',
    trade: {
      trade: 'Exterior Entrance Doors',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Fabrications',
    value: 'Exterior Fabrications',
    trade: {
      trade: 'Exterior Fabrications',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Fixed Grilles and Screens',
    value: 'Exterior Fixed Grilles and Screens',
    trade: {
      trade: 'Exterior Fixed Grilles and Screens',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Fixed Windows',
    value: 'Exterior Fixed Windows',
    trade: { trade: 'Exterior Fixed Windows', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Exterior Fountains',
    value: 'Exterior Fountains',
    trade: { trade: 'Exterior Fountains', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Exterior Gas Lighting',
    value: 'Exterior Gas Lighting',
    trade: {
      trade: 'Exterior Gas Lighting',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Gates',
    value: 'Exterior Gates',
    trade: {
      trade: 'Exterior Gates',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Grilles',
    value: 'Exterior Grilles',
    trade: {
      trade: 'Exterior Grilles',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Horizontal Enclosures',
    value: 'Exterior Horizontal Enclosures',
    trade: {
      trade: 'Exterior Horizontal Enclosures',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Lighting Supplementary Components',
    value: 'Exterior Lighting Supplementary Components',
    trade: {
      trade: 'Exterior Lighting Supplementary Components',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Louvers',
    value: 'Exterior Louvers',
    trade: {
      trade: 'Exterior Louvers',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Louvers and Vents',
    value: 'Exterior Louvers and Vents',
    trade: {
      trade: 'Exterior Louvers and Vents',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Opening Protection Devices',
    value: 'Exterior Opening Protection Devices',
    trade: {
      trade: 'Exterior Opening Protection Devices',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Operating Windows',
    value: 'Exterior Operating Windows',
    trade: {
      trade: 'Exterior Operating Windows',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Oversize Doors',
    value: 'Exterior Oversize Doors',
    trade: {
      trade: 'Exterior Oversize Doors',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Painting',
    value: 'Exterior Painting',
    trade: { trade: 'Exterior Painting', category: 'Paint', sortOrder: 0 }
  },
  {
    label: 'Exterior Parking Control Equipment',
    value: 'Exterior Parking Control Equipment',
    trade: {
      trade: 'Exterior Parking Control Equipment',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Pedestrian Control Equipment',
    value: 'Exterior Pedestrian Control Equipment',
    trade: {
      trade: 'Exterior Pedestrian Control Equipment',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Signage',
    value: 'Exterior Signage',
    trade: { trade: 'Exterior Signage', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Exterior Soffits',
    value: 'Exterior Soffits',
    trade: { trade: 'Exterior Soffits', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Exterior Special Function Doors',
    value: 'Exterior Special Function Doors',
    trade: {
      trade: 'Exterior Special Function Doors',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Special Function Windows',
    value: 'Exterior Special Function Windows',
    trade: {
      trade: 'Exterior Special Function Windows',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Steps and Ramps',
    value: 'Exterior Steps and Ramps',
    trade: {
      trade: 'Exterior Steps and Ramps',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Utility Doors',
    value: 'Exterior Utility Doors',
    trade: {
      trade: 'Exterior Utility Doors',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Vents',
    value: 'Exterior Vents',
    trade: {
      trade: 'Exterior Vents',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Vertical Enclosures',
    value: 'Exterior Vertical Enclosures',
    trade: {
      trade: 'Exterior Vertical Enclosures',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Appurtenances',
    value: 'Exterior Wall Appurtenances',
    trade: {
      trade: 'Exterior Wall Appurtenances',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Construction',
    value: 'Exterior Wall Construction',
    trade: {
      trade: 'Exterior Wall Construction',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Interior Skin',
    value: 'Exterior Wall Interior Skin',
    trade: {
      trade: 'Exterior Wall Interior Skin',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Opening Supplementary Components',
    value: 'Exterior Wall Opening Supplementary Components',
    trade: {
      trade: 'Exterior Wall Opening Supplementary Components',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Specialties',
    value: 'Exterior Wall Specialties',
    trade: {
      trade: 'Exterior Wall Specialties',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Supplementary Components',
    value: 'Exterior Wall Supplementary Components',
    trade: {
      trade: 'Exterior Wall Supplementary Components',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Exterior Wall Veneer',
    value: 'Exterior Wall Veneer',
    trade: { trade: 'Exterior Wall Veneer', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Exterior Walls',
    value: 'Exterior Walls',
    trade: { trade: 'Exterior Walls', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Exterior Window Wall',
    value: 'Exterior Window Wall',
    trade: { trade: 'Exterior Window Wall', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Exterior Windows',
    value: 'Exterior Windows',
    trade: { trade: 'Exterior Windows', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Fabric Structures',
    value: 'Fabric Structures',
    trade: {
      trade: 'Fabric Structures',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Fabricated Exterior Wall Assemblies',
    value: 'Fabricated Exterior Wall Assemblies',
    trade: {
      trade: 'Fabricated Exterior Wall Assemblies',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Fabrication Services and Supply',
    value: 'Fabrication Services and Supply',
    trade: {
      trade: 'Fabrication Services and Supply',
      category: 'Supplier',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Distribution Systems Supplementary Components',
    value: 'Facility Distribution Systems Supplementary Components',
    trade: {
      trade: 'Facility Distribution Systems Supplementary Components',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Fuel Systems',
    value: 'Facility Fuel Systems',
    trade: { trade: 'Facility Fuel Systems', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Facility Grounding',
    value: 'Facility Grounding',
    trade: { trade: 'Facility Grounding', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Facility HVAC Distribution Systems',
    value: 'Facility HVAC Distribution Systems',
    trade: {
      trade: 'Facility HVAC Distribution Systems',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Hydronic Distribution',
    value: 'Facility Hydronic Distribution',
    trade: {
      trade: 'Facility Hydronic Distribution',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Potable-Water Storage Tanks',
    value: 'Facility Potable-Water Storage Tanks',
    trade: {
      trade: 'Facility Potable-Water Storage Tanks',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Power Generation',
    value: 'Facility Power Generation',
    trade: {
      trade: 'Facility Power Generation',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Power Generation Supplementary Components',
    value: 'Facility Power Generation Supplementary Components',
    trade: {
      trade: 'Facility Power Generation Supplementary Components',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Remediation',
    value: 'Facility Remediation',
    trade: {
      trade: 'Facility Remediation',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Restoration',
    value: 'Facility Restoration',
    trade: {
      trade: 'Facility Restoration',
      category: 'Restoration',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Steam Distribution',
    value: 'Facility Steam Distribution',
    trade: {
      trade: 'Facility Steam Distribution',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Facility Stormwater Drains',
    value: 'Facility Stormwater Drains',
    trade: {
      trade: 'Facility Stormwater Drains',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Fence Erection / Construction Fencing',
    value: 'Fence Erection / Construction Fencing',
    trade: {
      trade: 'Fence Erection / Construction Fencing',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Fences and Gates',
    value: 'Fences and Gates',
    trade: { trade: 'Fences and Gates', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Fiber Cement Siding',
    value: 'Fiber Cement Siding',
    trade: { trade: 'Fiber Cement Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Finish Carpentry Contracting',
    value: 'Finish Carpentry Contracting',
    trade: {
      trade: 'Finish Carpentry Contracting',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Finish Plumbing',
    value: 'Finish Plumbing',
    trade: { trade: 'Finish Plumbing', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Fire Detection and Alarm',
    value: 'Fire Detection and Alarm',
    trade: {
      trade: 'Fire Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Escapes',
    value: 'Fire Escapes',
    trade: { trade: 'Fire Escapes', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Fire Extinguisher Accessories',
    value: 'Fire Extinguisher Accessories',
    trade: {
      trade: 'Fire Extinguisher Accessories',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Extinguishers',
    value: 'Fire Extinguishers',
    trade: {
      trade: 'Fire Extinguishers',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Place Installation and Maintenance',
    value: 'Fire Place Installation and Maintenance',
    trade: {
      trade: 'Fire Place Installation and Maintenance',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Protection',
    value: 'Fire Protection',
    trade: {
      trade: 'Fire Protection',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Protection Cabinets',
    value: 'Fire Protection Cabinets',
    trade: {
      trade: 'Fire Protection Cabinets',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Protection Specialties',
    value: 'Fire Protection Specialties',
    trade: {
      trade: 'Fire Protection Specialties',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Suppression',
    value: 'Fire Suppression',
    trade: {
      trade: 'Fire Suppression',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire Suppression Supplementary Components',
    value: 'Fire Suppression Supplementary Components',
    trade: {
      trade: 'Fire Suppression Supplementary Components',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fire-Extinguishing',
    value: 'Fire-Extinguishing',
    trade: {
      trade: 'Fire-Extinguishing',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fireplaces and Stoves',
    value: 'Fireplaces and Stoves',
    trade: {
      trade: 'Fireplaces and Stoves',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Fixed Art',
    value: 'Fixed Art',
    trade: { trade: 'Fixed Art', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Fixed Furnishings',
    value: 'Fixed Furnishings',
    trade: { trade: 'Fixed Furnishings', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Fixed Multiple Seating',
    value: 'Fixed Multiple Seating',
    trade: {
      trade: 'Fixed Multiple Seating',
      category: 'Furnishings',
      sortOrder: 0
    }
  },
  {
    label: 'Flagpoles',
    value: 'Flagpoles',
    trade: { trade: 'Flagpoles', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Flood Lighting',
    value: 'Flood Lighting',
    trade: { trade: 'Flood Lighting', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Floor Construction',
    value: 'Floor Construction',
    trade: { trade: 'Floor Construction', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Floor Construction Supplementary Components',
    value: 'Floor Construction Supplementary Components',
    trade: {
      trade: 'Floor Construction Supplementary Components',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Floor Decks, Slabs, and Toppings',
    value: 'Floor Decks, Slabs, and Toppings',
    trade: {
      trade: 'Floor Decks, Slabs, and Toppings',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Floor Sockets',
    value: 'Floor Sockets',
    trade: { trade: 'Floor Sockets', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Floor Structural Frame',
    value: 'Floor Structural Frame',
    trade: {
      trade: 'Floor Structural Frame',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Flooring',
    value: 'Flooring',
    trade: { trade: 'Flooring', category: 'Floors Stairs', sortOrder: 0 }
  },
  {
    label: 'Flooring Supplementary Components',
    value: 'Flooring Supplementary Components',
    trade: {
      trade: 'Flooring Supplementary Components',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Flooring Treatment',
    value: 'Flooring Treatment',
    trade: {
      trade: 'Flooring Treatment',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Fluid-Applied Flooring',
    value: 'Fluid-Applied Flooring',
    trade: {
      trade: 'Fluid-Applied Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Foodservice Equipment',
    value: 'Foodservice Equipment',
    trade: {
      trade: 'Foodservice Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Foundation Anchors',
    value: 'Foundation Anchors',
    trade: {
      trade: 'Foundation Anchors',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Foundation Drainage',
    value: 'Foundation Drainage',
    trade: {
      trade: 'Foundation Drainage',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Foundation Preparation',
    value: 'Foundation Preparation',
    trade: {
      trade: 'Foundation Preparation',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Foundations',
    value: 'Foundations',
    trade: {
      trade: 'Foundations',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Fuel Cells',
    value: 'Fuel Cells',
    trade: { trade: 'Fuel Cells', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Fuel Piping',
    value: 'Fuel Piping',
    trade: { trade: 'Fuel Piping', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Fuel Pumps',
    value: 'Fuel Pumps',
    trade: { trade: 'Fuel Pumps', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Fuel Storage Tanks',
    value: 'Fuel Storage Tanks',
    trade: { trade: 'Fuel Storage Tanks', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Fuel-Gas Detection and Alarm',
    value: 'Fuel-Gas Detection and Alarm',
    trade: {
      trade: 'Fuel-Gas Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Fuel-Oil Detection and Alarm',
    value: 'Fuel-Oil Detection and Alarm',
    trade: {
      trade: 'Fuel-Oil Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Furnishings',
    value: 'Furnishings',
    trade: { trade: 'Furnishings', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Furniture',
    value: 'Furniture',
    trade: { trade: 'Furniture', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Furniture Supplier',
    value: 'Furniture Supplier',
    trade: { trade: 'Furniture Supplier', category: 'Supplier', sortOrder: 0 }
  },
  {
    label: 'Gabions',
    value: 'Gabions',
    trade: { trade: 'Gabions', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Garage Doors',
    value: 'Garage Doors',
    trade: {
      trade: 'Garage Doors',
      category: 'Exterior Enclosure',
      sortOrder: 0
    }
  },
  {
    label: 'Gas Systems',
    value: 'Gas Systems',
    trade: { trade: 'Gas Systems', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Gas Utility',
    value: 'Gas Utility',
    trade: { trade: 'Gas Utility', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'General Concrete Contracting',
    value: 'General Concrete Contracting',
    trade: {
      trade: 'General Concrete Contracting',
      category: 'Masonry',
      sortOrder: 0
    }
  },
  {
    label: 'General Construction Labor',
    value: 'General Construction Labor',
    trade: {
      trade: 'General Construction Labor',
      category: 'Labor',
      sortOrder: 0
    }
  },
  {
    label: 'General Purpose Electrical Power',
    value: 'General Purpose Electrical Power',
    trade: {
      trade: 'General Purpose Electrical Power',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'General Purpose Electrical Power Supplementary Components',
    value: 'General Purpose Electrical Power Supplementary Components',
    trade: {
      trade: 'General Purpose Electrical Power Supplementary Components',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'General Service Compressed-Air',
    value: 'General Service Compressed-Air',
    trade: {
      trade: 'General Service Compressed-Air',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Geodesic Structures',
    value: 'Geodesic Structures',
    trade: {
      trade: 'Geodesic Structures',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Geothermal Service',
    value: 'Geothermal Service',
    trade: { trade: 'Geothermal Service', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Glass Doors',
    value: 'Glass Doors',
    trade: { trade: 'Glass Doors', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Glazing Contracting - Other',
    value: 'Glazing Contracting - Other',
    trade: {
      trade: 'Glazing Contracting - Other',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Grade Beams',
    value: 'Grade Beams',
    trade: {
      trade: 'Grade Beams',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Grading',
    value: 'Grading',
    trade: { trade: 'Grading', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Gray Water Systems',
    value: 'Gray Water Systems',
    trade: { trade: 'Gray Water Systems', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Ground Freezing',
    value: 'Ground Freezing',
    trade: {
      trade: 'Ground Freezing',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Grounds Maintenance Workers',
    value: 'Grounds Maintenance Workers',
    trade: {
      trade: 'Grounds Maintenance Workers',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Gutters',
    value: 'Gutters',
    trade: { trade: 'Gutters', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'HVAC Air Cleaning',
    value: 'HVAC Air Cleaning',
    trade: { trade: 'HVAC Air Cleaning', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'HVAC Air Distribution',
    value: 'HVAC Air Distribution',
    trade: { trade: 'HVAC Air Distribution', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'HVAC Contracting',
    value: 'HVAC Contracting',
    trade: { trade: 'HVAC Contracting', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Hazardous Material Abatement',
    value: 'Hazardous Material Abatement',
    trade: {
      trade: 'Hazardous Material Abatement',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Hazardous Materials Remediation',
    value: 'Hazardous Materials Remediation',
    trade: {
      trade: 'Hazardous Materials Remediation',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Hazardous Waste Drum Handling',
    value: 'Hazardous Waste Drum Handling',
    trade: {
      trade: 'Hazardous Waste Drum Handling',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Healthcare Communications and Monitoring',
    value: 'Healthcare Communications and Monitoring',
    trade: {
      trade: 'Healthcare Communications and Monitoring',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Healthcare Equipment',
    value: 'Healthcare Equipment',
    trade: {
      trade: 'Healthcare Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Heat Generation',
    value: 'Heat Generation',
    trade: { trade: 'Heat Generation', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Heating System Supplementary Components',
    value: 'Heating System Supplementary Components',
    trade: {
      trade: 'Heating System Supplementary Components',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Heating Systems',
    value: 'Heating Systems',
    trade: { trade: 'Heating Systems', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Heating, Ventilation and Air Conditioning',
    value: 'Heating, Ventilation and Air Conditioning',
    trade: {
      trade: 'Heating, Ventilation and Air Conditioning',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Heating, Ventilation, and Air Conditioning (HVAC)',
    value: 'Heating, Ventilation, and Air Conditioning (HVAC)',
    trade: {
      trade: 'Heating, Ventilation, and Air Conditioning (HVAC)',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'High Voltage - more than 1000 volts',
    value: 'High Voltage - more than 1000 volts',
    trade: {
      trade: 'High Voltage - more than 1000 volts',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Hoist and Winch Operation',
    value: 'Hoist and Winch Operation',
    trade: {
      trade: 'Hoist and Winch Operation',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Hoists',
    value: 'Hoists',
    trade: {
      trade: 'Hoists',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Home Appliance Installation and Maintenance',
    value: 'Home Appliance Installation and Maintenance',
    trade: {
      trade: 'Home Appliance Installation and Maintenance',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Home Theater Installers',
    value: 'Home Theater Installers',
    trade: {
      trade: 'Home Theater Installers',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Horizontal Conveying',
    value: 'Horizontal Conveying',
    trade: {
      trade: 'Horizontal Conveying',
      category: 'Conveying',
      sortOrder: 0
    }
  },
  {
    label: 'Horizontal Enclosure Supplementary Components',
    value: 'Horizontal Enclosure Supplementary Components',
    trade: {
      trade: 'Horizontal Enclosure Supplementary Components',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Horizontal Opening Supplementary Components',
    value: 'Horizontal Opening Supplementary Components',
    trade: {
      trade: 'Horizontal Opening Supplementary Components',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Horizontal Openings',
    value: 'Horizontal Openings',
    trade: { trade: 'Horizontal Openings', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Horizontal Waterproofing Membrane',
    value: 'Horizontal Waterproofing Membrane',
    trade: {
      trade: 'Horizontal Waterproofing Membrane',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Horticultural Equipment',
    value: 'Horticultural Equipment',
    trade: {
      trade: 'Horticultural Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Hospitality Equipment',
    value: 'Hospitality Equipment',
    trade: {
      trade: 'Hospitality Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Hydroligical Control (Dewatering)',
    value: 'Hydroligical Control (Dewatering)',
    trade: {
      trade: 'Hydroligical Control (Dewatering)',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Ice Rinks',
    value: 'Ice Rinks',
    trade: { trade: 'Ice Rinks', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Indoor Soccer Boards',
    value: 'Indoor Soccer Boards',
    trade: {
      trade: 'Indoor Soccer Boards',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Industrial Truck and Tractor Operation',
    value: 'Industrial Truck and Tractor Operation',
    trade: {
      trade: 'Industrial Truck and Tractor Operation',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Information Specialties',
    value: 'Information Specialties',
    trade: {
      trade: 'Information Specialties',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Infrastructure Demolition',
    value: 'Infrastructure Demolition',
    trade: {
      trade: 'Infrastructure Demolition',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Institutional Equipment',
    value: 'Institutional Equipment',
    trade: {
      trade: 'Institutional Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Insulating',
    value: 'Insulating',
    trade: { trade: 'Insulating', category: 'Insulation', sortOrder: 0 }
  },
  {
    label: 'Insulating Contracting',
    value: 'Insulating Contracting',
    trade: {
      trade: 'Insulating Contracting',
      category: 'Insulation',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation',
    value: 'Integrated Automation',
    trade: {
      trade: 'Integrated Automation',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of Communication Systems',
    value: 'Integrated Automation Control of Communication Systems',
    trade: {
      trade: 'Integrated Automation Control of Communication Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of Conveying Equipment',
    value: 'Integrated Automation Control of Conveying Equipment',
    trade: {
      trade: 'Integrated Automation Control of Conveying Equipment',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of Electrical Systems',
    value: 'Integrated Automation Control of Electrical Systems',
    trade: {
      trade: 'Integrated Automation Control of Electrical Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label:
      'Integrated Automation Control of Electronic Safety and Security Systems',
    value:
      'Integrated Automation Control of Electronic Safety and Security Systems',
    trade: {
      trade:
        'Integrated Automation Control of Electronic Safety and Security Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of Equipment',
    value: 'Integrated Automation Control of Equipment',
    trade: {
      trade: 'Integrated Automation Control of Equipment',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of Fire-Suppression Systems',
    value: 'Integrated Automation Control of Fire-Suppression Systems',
    trade: {
      trade: 'Integrated Automation Control of Fire-Suppression Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of HVAC Systems',
    value: 'Integrated Automation Control of HVAC Systems',
    trade: {
      trade: 'Integrated Automation Control of HVAC Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Control of Plumbing Systems',
    value: 'Integrated Automation Control of Plumbing Systems',
    trade: {
      trade: 'Integrated Automation Control of Plumbing Systems',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Facility Controls',
    value: 'Integrated Automation Facility Controls',
    trade: {
      trade: 'Integrated Automation Facility Controls',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Automation Supplementary Components',
    value: 'Integrated Automation Supplementary Components',
    trade: {
      trade: 'Integrated Automation Supplementary Components',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Integrated Construction',
    value: 'Integrated Construction',
    trade: {
      trade: 'Integrated Construction',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Access Doors and Panels',
    value: 'Interior Access Doors and Panels',
    trade: {
      trade: 'Interior Access Doors and Panels',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Coiling Doors',
    value: 'Interior Coiling Doors',
    trade: {
      trade: 'Interior Coiling Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Construction',
    value: 'Interior Construction',
    trade: {
      trade: 'Interior Construction',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Demountable Partitions',
    value: 'Interior Demountable Partitions',
    trade: {
      trade: 'Interior Demountable Partitions',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Door Supplementary Components',
    value: 'Interior Door Supplementary Components',
    trade: {
      trade: 'Interior Door Supplementary Components',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Doors',
    value: 'Interior Doors',
    trade: {
      trade: 'Interior Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Entrance Doors',
    value: 'Interior Entrance Doors',
    trade: {
      trade: 'Interior Entrance Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Fabrications',
    value: 'Interior Fabrications',
    trade: {
      trade: 'Interior Fabrications',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Finishes',
    value: 'Interior Finishes',
    trade: {
      trade: 'Interior Finishes',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Fixed Partitions',
    value: 'Interior Fixed Partitions',
    trade: {
      trade: 'Interior Fixed Partitions',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Fixed Windows',
    value: 'Interior Fixed Windows',
    trade: { trade: 'Interior Fixed Windows', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Interior Folding Doors',
    value: 'Interior Folding Doors',
    trade: {
      trade: 'Interior Folding Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Fountains',
    value: 'Interior Fountains',
    trade: {
      trade: 'Interior Fountains',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Gas Lighting',
    value: 'Interior Gas Lighting',
    trade: {
      trade: 'Interior Gas Lighting',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Gates',
    value: 'Interior Gates',
    trade: {
      trade: 'Interior Gates',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Glazed Partitions',
    value: 'Interior Glazed Partitions',
    trade: {
      trade: 'Interior Glazed Partitions',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Grilles',
    value: 'Interior Grilles',
    trade: {
      trade: 'Interior Grilles',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Grilles and Gates',
    value: 'Interior Grilles and Gates',
    trade: {
      trade: 'Interior Grilles and Gates',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Louvers',
    value: 'Interior Louvers',
    trade: {
      trade: 'Interior Louvers',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Operable Partitions',
    value: 'Interior Operable Partitions',
    trade: {
      trade: 'Interior Operable Partitions',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Operating Windows',
    value: 'Interior Operating Windows',
    trade: {
      trade: 'Interior Operating Windows',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Painting',
    value: 'Interior Painting',
    trade: { trade: 'Interior Painting', category: 'Paint', sortOrder: 0 }
  },
  {
    label: 'Interior Panel Doors',
    value: 'Interior Panel Doors',
    trade: {
      trade: 'Interior Panel Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Parking Control Equipment',
    value: 'Interior Parking Control Equipment',
    trade: {
      trade: 'Interior Parking Control Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Partition Supplementary Components',
    value: 'Interior Partition Supplementary Components',
    trade: {
      trade: 'Interior Partition Supplementary Components',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Partitions',
    value: 'Interior Partitions',
    trade: {
      trade: 'Interior Partitions',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Pedestrian Control Equipment',
    value: 'Interior Pedestrian Control Equipment',
    trade: {
      trade: 'Interior Pedestrian Control Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Railings and Handrails',
    value: 'Interior Railings and Handrails',
    trade: {
      trade: 'Interior Railings and Handrails',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Screens',
    value: 'Interior Screens',
    trade: {
      trade: 'Interior Screens',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Sliding Doors',
    value: 'Interior Sliding Doors',
    trade: {
      trade: 'Interior Sliding Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Special Function Doors',
    value: 'Interior Special Function Doors',
    trade: {
      trade: 'Interior Special Function Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Special Function Windows',
    value: 'Interior Special Function Windows',
    trade: {
      trade: 'Interior Special Function Windows',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Specialties',
    value: 'Interior Specialties',
    trade: {
      trade: 'Interior Specialties',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Swinging Doors',
    value: 'Interior Swinging Doors',
    trade: {
      trade: 'Interior Swinging Doors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Trim',
    value: 'Interior Trim',
    trade: {
      trade: 'Interior Trim',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Water Features',
    value: 'Interior Water Features',
    trade: {
      trade: 'Interior Water Features',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Window Supplementary Components',
    value: 'Interior Window Supplementary Components',
    trade: {
      trade: 'Interior Window Supplementary Components',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Interior Windows',
    value: 'Interior Windows',
    trade: { trade: 'Interior Windows', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Interiors',
    value: 'Interiors',
    trade: {
      trade: 'Interiors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Intrusion Detection',
    value: 'Intrusion Detection',
    trade: {
      trade: 'Intrusion Detection',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Iron Work and Welding Contracting',
    value: 'Iron Work and Welding Contracting',
    trade: {
      trade: 'Iron Work and Welding Contracting',
      category: 'Welding',
      sortOrder: 0
    }
  },
  {
    label: 'Iron Working and Welding',
    value: 'Iron Working and Welding',
    trade: {
      trade: 'Iron Working and Welding',
      category: 'Welding',
      sortOrder: 0
    }
  },
  {
    label: 'Labor Contracting',
    value: 'Labor Contracting',
    trade: { trade: 'Labor Contracting', category: 'Labor', sortOrder: 0 }
  },
  {
    label: 'Laborers and Material Moving, Hand',
    value: 'Laborers and Material Moving, Hand',
    trade: {
      trade: 'Laborers and Material Moving, Hand',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Ladders',
    value: 'Ladders',
    trade: { trade: 'Ladders', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Landscape Contractor',
    value: 'Landscape Contractor',
    trade: {
      trade: 'Landscape Contractor',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Landscape Lighting',
    value: 'Landscape Lighting',
    trade: { trade: 'Landscape Lighting', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Landscaping',
    value: 'Landscaping',
    trade: { trade: 'Landscaping', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Landscaping Activities',
    value: 'Landscaping Activities',
    trade: {
      trade: 'Landscaping Activities',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Landscaping Arborist',
    value: 'Landscaping Arborist',
    trade: {
      trade: 'Landscaping Arborist',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Landscaping Asphalt (Asphalt Seal)',
    value: 'Landscaping Asphalt (Asphalt Seal)',
    trade: {
      trade: 'Landscaping Asphalt (Asphalt Seal)',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Landscaping Contractor',
    value: 'Landscaping Contractor',
    trade: {
      trade: 'Landscaping Contractor',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Landscaping Draining',
    value: 'Landscaping Draining',
    trade: {
      trade: 'Landscaping Draining',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Landscaping Fencing',
    value: 'Landscaping Fencing',
    trade: { trade: 'Landscaping Fencing', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Landscaping Mailbox',
    value: 'Landscaping Mailbox',
    trade: { trade: 'Landscaping Mailbox', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Landscaping Pavement contractor (concrete flatwork)',
    value: 'Landscaping Pavement contractor (concrete flatwork)',
    trade: {
      trade: 'Landscaping Pavement contractor (concrete flatwork)',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Lead Remediation',
    value: 'Lead Remediation',
    trade: { trade: 'Lead Remediation', category: 'Remediation', sortOrder: 0 }
  },
  {
    label: 'Lifts',
    value: 'Lifts',
    trade: { trade: 'Lifts', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Lighting',
    value: 'Lighting',
    trade: { trade: 'Lighting', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Lighting Control',
    value: 'Lighting Control',
    trade: { trade: 'Lighting Control', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Lighting Fixtures',
    value: 'Lighting Fixtures',
    trade: { trade: 'Lighting Fixtures', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Lighting Supplementary Components',
    value: 'Lighting Supplementary Components',
    trade: {
      trade: 'Lighting Supplementary Components',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Lightning Protection',
    value: 'Lightning Protection',
    trade: { trade: 'Lightning Protection', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Liquid and Gas Site Utilities',
    value: 'Liquid and Gas Site Utilities',
    trade: {
      trade: 'Liquid and Gas Site Utilities',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Liquid and Gas Site Utilities Supplementary Components',
    value: 'Liquid and Gas Site Utilities Supplementary Components',
    trade: {
      trade: 'Liquid and Gas Site Utilities Supplementary Components',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Loading Dock Equipment',
    value: 'Loading Dock Equipment',
    trade: {
      trade: 'Loading Dock Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Low-Slope Roofing',
    value: 'Low-Slope Roofing',
    trade: { trade: 'Low-Slope Roofing', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Maintenance Equipment',
    value: 'Maintenance Equipment',
    trade: {
      trade: 'Maintenance Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Manufactured Canopies',
    value: 'Manufactured Canopies',
    trade: {
      trade: 'Manufactured Canopies',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Manufactured/Fabricated Rooms',
    value: 'Manufactured/Fabricated Rooms',
    trade: {
      trade: 'Manufactured/Fabricated Rooms',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Manufacturer-Engineered Structures',
    value: 'Manufacturer-Engineered Structures',
    trade: {
      trade: 'Manufacturer-Engineered Structures',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Manufacturing Services and Supply',
    value: 'Manufacturing Services and Supply',
    trade: {
      trade: 'Manufacturing Services and Supply',
      category: 'Supplier',
      sortOrder: 0
    }
  },
  {
    label: 'Masonry',
    value: 'Masonry',
    trade: { trade: 'Masonry', category: 'Masonry', sortOrder: 0 }
  },
  {
    label: 'Masonry Contracting',
    value: 'Masonry Contracting',
    trade: { trade: 'Masonry Contracting', category: 'Masonry', sortOrder: 0 }
  },
  {
    label: 'Masonry Flooring',
    value: 'Masonry Flooring',
    trade: {
      trade: 'Masonry Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Masonry Restoration',
    value: 'Masonry Restoration',
    trade: {
      trade: 'Masonry Restoration',
      category: 'Restoration',
      sortOrder: 0
    }
  },
  {
    label: 'Masonry Stair Finish',
    value: 'Masonry Stair Finish',
    trade: {
      trade: 'Masonry Stair Finish',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Material Handling',
    value: 'Material Handling',
    trade: {
      trade: 'Material Handling',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Material Moving Contracting',
    value: 'Material Moving Contracting',
    trade: {
      trade: 'Material Moving Contracting',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Medium Voltage - less Than 1000 Volts (Home)',
    value: 'Medium Voltage - less Than 1000 Volts (Home)',
    trade: {
      trade: 'Medium Voltage - less Than 1000 Volts (Home)',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Mercantile and Service Equipment',
    value: 'Mercantile and Service Equipment',
    trade: {
      trade: 'Mercantile and Service Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Metal Siding',
    value: 'Metal Siding',
    trade: { trade: 'Metal Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Metal Walkways',
    value: 'Metal Walkways',
    trade: { trade: 'Metal Walkways', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Meteorological Instrumentation',
    value: 'Meteorological Instrumentation',
    trade: {
      trade: 'Meteorological Instrumentation',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Methane Mitigation',
    value: 'Methane Mitigation',
    trade: {
      trade: 'Methane Mitigation',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Mezzanine Floor Construction',
    value: 'Mezzanine Floor Construction',
    trade: {
      trade: 'Mezzanine Floor Construction',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Mirrors',
    value: 'Mirrors',
    trade: { trade: 'Mirrors', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Miscellaneous Electrical Systems',
    value: 'Miscellaneous Electrical Systems',
    trade: {
      trade: 'Miscellaneous Electrical Systems',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Miscellaneous Electrical Systems Supplementary Components',
    value: 'Miscellaneous Electrical Systems Supplementary Components',
    trade: {
      trade: 'Miscellaneous Electrical Systems Supplementary Components',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Miscellaneous Site Construction',
    value: 'Miscellaneous Site Construction',
    trade: {
      trade: 'Miscellaneous Site Construction',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Modular Mezzanines',
    value: 'Modular Mezzanines',
    trade: {
      trade: 'Modular Mezzanines',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Mold Remediation',
    value: 'Mold Remediation',
    trade: { trade: 'Mold Remediation', category: 'Remediation', sortOrder: 0 }
  },
  {
    label: 'Movable Art',
    value: 'Movable Art',
    trade: { trade: 'Movable Art', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Movable Furnishings',
    value: 'Movable Furnishings',
    trade: {
      trade: 'Movable Furnishings',
      category: 'Furnishings',
      sortOrder: 0
    }
  },
  {
    label: 'Movable Multiple Seating',
    value: 'Movable Multiple Seating',
    trade: {
      trade: 'Movable Multiple Seating',
      category: 'Furnishings',
      sortOrder: 0
    }
  },
  {
    label: 'Move In Contracting',
    value: 'Move In Contracting',
    trade: {
      trade: 'Move In Contracting',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Movers, Appliance Movers and Funiture Movers',
    value: 'Movers, Appliance Movers and Funiture Movers',
    trade: {
      trade: 'Movers, Appliance Movers and Funiture Movers',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Moving Ramps',
    value: 'Moving Ramps',
    trade: { trade: 'Moving Ramps', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Moving Walks',
    value: 'Moving Walks',
    trade: { trade: 'Moving Walks', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Mud Only',
    value: 'Mud Only',
    trade: { trade: 'Mud Only', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Mud Slab',
    value: 'Mud Slab',
    trade: {
      trade: 'Mud Slab',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Mud and Tape',
    value: 'Mud and Tape',
    trade: { trade: 'Mud and Tape', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Musical Equipment',
    value: 'Musical Equipment',
    trade: { trade: 'Musical Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Off-Gassing Mitigation',
    value: 'Off-Gassing Mitigation',
    trade: {
      trade: 'Off-Gassing Mitigation',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Office Equipment',
    value: 'Office Equipment',
    trade: { trade: 'Office Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Operable Access Systems',
    value: 'Operable Access Systems',
    trade: {
      trade: 'Operable Access Systems',
      category: 'Scaffolding',
      sortOrder: 0
    }
  },
  {
    label: 'Other Equipment',
    value: 'Other Equipment',
    trade: { trade: 'Other Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Other Fixed Furnishings',
    value: 'Other Fixed Furnishings',
    trade: {
      trade: 'Other Fixed Furnishings',
      category: 'Furnishings',
      sortOrder: 0
    }
  },
  {
    label: 'Other Interior Specialties',
    value: 'Other Interior Specialties',
    trade: {
      trade: 'Other Interior Specialties',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Other Movable Furnishings',
    value: 'Other Movable Furnishings',
    trade: {
      trade: 'Other Movable Furnishings',
      category: 'Furnishings',
      sortOrder: 0
    }
  },
  {
    label: 'Other Painting',
    value: 'Other Painting',
    trade: { trade: 'Other Painting', category: 'Paint', sortOrder: 0 }
  },
  {
    label: 'Outside Air',
    value: 'Outside Air',
    trade: { trade: 'Outside Air', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Overhead Exterior Enclosures',
    value: 'Overhead Exterior Enclosures',
    trade: {
      trade: 'Overhead Exterior Enclosures',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Packaged Generator Assemblies',
    value: 'Packaged Generator Assemblies',
    trade: {
      trade: 'Packaged Generator Assemblies',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Parapets',
    value: 'Parapets',
    trade: { trade: 'Parapets', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Parking Lot Appurtenances',
    value: 'Parking Lot Appurtenances',
    trade: {
      trade: 'Parking Lot Appurtenances',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Parking Lot Curbs and Gutters',
    value: 'Parking Lot Curbs and Gutters',
    trade: {
      trade: 'Parking Lot Curbs and Gutters',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Parking Lot Lighting',
    value: 'Parking Lot Lighting',
    trade: { trade: 'Parking Lot Lighting', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Parking Lot Pavement',
    value: 'Parking Lot Pavement',
    trade: { trade: 'Parking Lot Pavement', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Parking Lots',
    value: 'Parking Lots',
    trade: { trade: 'Parking Lots', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Parking Restoration',
    value: 'Parking Restoration',
    trade: {
      trade: 'Parking Restoration',
      category: 'Restoration',
      sortOrder: 0
    }
  },
  {
    label: 'Passenger Loading Bridges',
    value: 'Passenger Loading Bridges',
    trade: {
      trade: 'Passenger Loading Bridges',
      category: 'Conveying',
      sortOrder: 0
    }
  },
  {
    label: 'Pedestrian Pavement',
    value: 'Pedestrian Pavement',
    trade: { trade: 'Pedestrian Pavement', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Pedestrian Pavement Appurtenances',
    value: 'Pedestrian Pavement Appurtenances',
    trade: {
      trade: 'Pedestrian Pavement Appurtenances',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Pedestrian Pavement Curbs and Gutters',
    value: 'Pedestrian Pavement Curbs and Gutters',
    trade: {
      trade: 'Pedestrian Pavement Curbs and Gutters',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Pedestrian Plazas and Walkways',
    value: 'Pedestrian Plazas and Walkways',
    trade: {
      trade: 'Pedestrian Plazas and Walkways',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Pedestrian Tunnels',
    value: 'Pedestrian Tunnels',
    trade: {
      trade: 'Pedestrian Tunnels',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'People Movers',
    value: 'People Movers',
    trade: { trade: 'People Movers', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Perimeter Insulation',
    value: 'Perimeter Insulation',
    trade: {
      trade: 'Perimeter Insulation',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Pest Control',
    value: 'Pest Control',
    trade: { trade: 'Pest Control', category: 'Cleaning', sortOrder: 0 }
  },
  {
    label: 'Photographic Processing Equipment',
    value: 'Photographic Processing Equipment',
    trade: {
      trade: 'Photographic Processing Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Photovoltaic Collectors',
    value: 'Photovoltaic Collectors',
    trade: {
      trade: 'Photovoltaic Collectors',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Physical Decontamination',
    value: 'Physical Decontamination',
    trade: {
      trade: 'Physical Decontamination',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Pile Caps',
    value: 'Pile Caps',
    trade: {
      trade: 'Pile Caps',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Pits and Bases',
    value: 'Pits and Bases',
    trade: {
      trade: 'Pits and Bases',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Planting Accessories',
    value: 'Planting Accessories',
    trade: {
      trade: 'Planting Accessories',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Planting Irrigation',
    value: 'Planting Irrigation',
    trade: { trade: 'Planting Irrigation', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Plants',
    value: 'Plants',
    trade: { trade: 'Plants', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Plaster and Gypsum Board Finish',
    value: 'Plaster and Gypsum Board Finish',
    trade: {
      trade: 'Plaster and Gypsum Board Finish',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Platform/Stage Floors',
    value: 'Platform/Stage Floors',
    trade: {
      trade: 'Platform/Stage Floors',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Playfield Areas',
    value: 'Playfield Areas',
    trade: { trade: 'Playfield Areas', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Plaza and Walkway Lighting',
    value: 'Plaza and Walkway Lighting',
    trade: {
      trade: 'Plaza and Walkway Lighting',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Plumbing',
    value: 'Plumbing',
    trade: { trade: 'Plumbing', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Plumbing - Other',
    value: 'Plumbing - Other',
    trade: { trade: 'Plumbing - Other', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Plumbing Fixtures',
    value: 'Plumbing Fixtures',
    trade: { trade: 'Plumbing Fixtures', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Pneumatic Tube Systems',
    value: 'Pneumatic Tube Systems',
    trade: {
      trade: 'Pneumatic Tube Systems',
      category: 'Material Moving Handling',
      sortOrder: 0
    }
  },
  {
    label: 'Polychlorinate Biphenyl Remediation',
    value: 'Polychlorinate Biphenyl Remediation',
    trade: {
      trade: 'Polychlorinate Biphenyl Remediation',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Pools',
    value: 'Pools',
    trade: { trade: 'Pools', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Postal, Packaging, and Shipping Equipment',
    value: 'Postal, Packaging, and Shipping Equipment',
    trade: {
      trade: 'Postal, Packaging, and Shipping Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Power Distribution',
    value: 'Power Distribution',
    trade: { trade: 'Power Distribution', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Power Filtering and Conditioning',
    value: 'Power Filtering and Conditioning',
    trade: {
      trade: 'Power Filtering and Conditioning',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Powered Scaffolding',
    value: 'Powered Scaffolding',
    trade: {
      trade: 'Powered Scaffolding',
      category: 'Scaffolding',
      sortOrder: 0
    }
  },
  {
    label: 'Process Manufacturing',
    value: 'Process Manufacturing',
    trade: {
      trade: 'Process Manufacturing',
      category: 'Supplier',
      sortOrder: 0
    }
  },
  {
    label: 'Process Support Plumbing System Supplementary Components',
    value: 'Process Support Plumbing System Supplementary Components',
    trade: {
      trade: 'Process Support Plumbing System Supplementary Components',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Process Support Plumbing Systems',
    value: 'Process Support Plumbing Systems',
    trade: {
      trade: 'Process Support Plumbing Systems',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Processed Water Systems',
    value: 'Processed Water Systems',
    trade: {
      trade: 'Processed Water Systems',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Radiation Detection and Alarm',
    value: 'Radiation Detection and Alarm',
    trade: {
      trade: 'Radiation Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Radiation Protection',
    value: 'Radiation Protection',
    trade: {
      trade: 'Radiation Protection',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Radon Mitigation',
    value: 'Radon Mitigation',
    trade: {
      trade: 'Radon Mitigation',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Raft Foundations',
    value: 'Raft Foundations',
    trade: {
      trade: 'Raft Foundations',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Rainwater Management',
    value: 'Rainwater Management',
    trade: { trade: 'Rainwater Management', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Raised Floor Construction',
    value: 'Raised Floor Construction',
    trade: {
      trade: 'Raised Floor Construction',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Rammed Earth Construction',
    value: 'Rammed Earth Construction',
    trade: {
      trade: 'Rammed Earth Construction',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Ramps',
    value: 'Ramps',
    trade: { trade: 'Ramps', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Recreational Areas',
    value: 'Recreational Areas',
    trade: {
      trade: 'Recreational Areas',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Recreational Equipment',
    value: 'Recreational Equipment',
    trade: {
      trade: 'Recreational Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Refrigerated Display Equipment',
    value: 'Refrigerated Display Equipment',
    trade: {
      trade: 'Refrigerated Display Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Refrigeration',
    value: 'Refrigeration',
    trade: { trade: 'Refrigeration', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Refrigeration Contracting',
    value: 'Refrigeration Contracting',
    trade: {
      trade: 'Refrigeration Contracting',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Refrigeration Detection and Alarm',
    value: 'Refrigeration Detection and Alarm',
    trade: {
      trade: 'Refrigeration Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Reinforcing Iron and Rebar Fabrication',
    value: 'Reinforcing Iron and Rebar Fabrication',
    trade: {
      trade: 'Reinforcing Iron and Rebar Fabrication',
      category: 'Welding',
      sortOrder: 0
    }
  },
  {
    label: 'Religious Equipment',
    value: 'Religious Equipment',
    trade: { trade: 'Religious Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Remediation',
    value: 'Remediation',
    trade: { trade: 'Remediation', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Remediation Soil Stabilization',
    value: 'Remediation Soil Stabilization',
    trade: {
      trade: 'Remediation Soil Stabilization',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Residential Appliances',
    value: 'Residential Appliances',
    trade: {
      trade: 'Residential Appliances',
      category: 'Furnishings',
      sortOrder: 0
    }
  },
  {
    label: 'Residential Ceiling Fans',
    value: 'Residential Ceiling Fans',
    trade: {
      trade: 'Residential Ceiling Fans',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Residential Equipment',
    value: 'Residential Equipment',
    trade: {
      trade: 'Residential Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Resilient Flooring',
    value: 'Resilient Flooring',
    trade: {
      trade: 'Resilient Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Resilient Stair Finish',
    value: 'Resilient Stair Finish',
    trade: {
      trade: 'Resilient Stair Finish',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Restoration Services',
    value: 'Restoration Services',
    trade: {
      trade: 'Restoration Services',
      category: 'Restoration',
      sortOrder: 0
    }
  },
  {
    label: 'Restoration Services - General',
    value: 'Restoration Services - General',
    trade: {
      trade: 'Restoration Services - General',
      category: 'Restoration',
      sortOrder: 0
    }
  },
  {
    label: 'Retaining Walls',
    value: 'Retaining Walls',
    trade: { trade: 'Retaining Walls', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Retractable Stairs',
    value: 'Retractable Stairs',
    trade: { trade: 'Retractable Stairs', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Return Air',
    value: 'Return Air',
    trade: { trade: 'Return Air', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Riprap',
    value: 'Riprap',
    trade: { trade: 'Riprap', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Roadway Appurtenances',
    value: 'Roadway Appurtenances',
    trade: { trade: 'Roadway Appurtenances', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Roadway Curbs and Gutters',
    value: 'Roadway Curbs and Gutters',
    trade: {
      trade: 'Roadway Curbs and Gutters',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Roadway Lighting',
    value: 'Roadway Lighting',
    trade: { trade: 'Roadway Lighting', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Roadway Pavement',
    value: 'Roadway Pavement',
    trade: { trade: 'Roadway Pavement', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Roadways',
    value: 'Roadways',
    trade: { trade: 'Roadways', category: 'Roadway', sortOrder: 0 }
  },
  {
    label: 'Rock Stabilization',
    value: 'Rock Stabilization',
    trade: { trade: 'Rock Stabilization', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Roof Accessories',
    value: 'Roof Accessories',
    trade: { trade: 'Roof Accessories', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Roof Appurtenances',
    value: 'Roof Appurtenances',
    trade: { trade: 'Roof Appurtenances', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Roof Construction',
    value: 'Roof Construction',
    trade: { trade: 'Roof Construction', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Roof Construction Supplementary Components',
    value: 'Roof Construction Supplementary Components',
    trade: {
      trade: 'Roof Construction Supplementary Components',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Roof Decks, Slabs, and Sheathing',
    value: 'Roof Decks, Slabs, and Sheathing',
    trade: {
      trade: 'Roof Decks, Slabs, and Sheathing',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Roof Specialties',
    value: 'Roof Specialties',
    trade: { trade: 'Roof Specialties', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Roof Structural Frame',
    value: 'Roof Structural Frame',
    trade: {
      trade: 'Roof Structural Frame',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Roof Windows and Skylights',
    value: 'Roof Windows and Skylights',
    trade: {
      trade: 'Roof Windows and Skylights',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Roofing',
    value: 'Roofing',
    trade: { trade: 'Roofing', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Roofing Supplementary Components',
    value: 'Roofing Supplementary Components',
    trade: {
      trade: 'Roofing Supplementary Components',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Rope Climbers',
    value: 'Rope Climbers',
    trade: { trade: 'Rope Climbers', category: 'Scaffolding', sortOrder: 0 }
  },
  {
    label: 'Rough Carpentry Contracting',
    value: 'Rough Carpentry Contracting',
    trade: {
      trade: 'Rough Carpentry Contracting',
      category: 'Structure',
      sortOrder: 0
    }
  },
  {
    label: 'Rough in Plumbing',
    value: 'Rough in Plumbing',
    trade: { trade: 'Rough in Plumbing', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Safety Netting',
    value: 'Safety Netting',
    trade: { trade: 'Safety Netting', category: 'Recreational', sortOrder: 0 }
  },
  {
    label: 'Safety Specialties',
    value: 'Safety Specialties',
    trade: {
      trade: 'Safety Specialties',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Drainage',
    value: 'Sanitary Drainage',
    trade: { trade: 'Sanitary Drainage', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Sanitary Drainage Supplementary Components',
    value: 'Sanitary Drainage Supplementary Components',
    trade: {
      trade: 'Sanitary Drainage Supplementary Components',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Equipment',
    value: 'Sanitary Sewerage Equipment',
    trade: {
      trade: 'Sanitary Sewerage Equipment',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Lagoons',
    value: 'Sanitary Sewerage Lagoons',
    trade: {
      trade: 'Sanitary Sewerage Lagoons',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Piping',
    value: 'Sanitary Sewerage Piping',
    trade: {
      trade: 'Sanitary Sewerage Piping',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Piping',
    value: 'Sanitary Sewerage Piping',
    trade: {
      trade: 'Sanitary Sewerage Piping',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Structures',
    value: 'Sanitary Sewerage Structures',
    trade: {
      trade: 'Sanitary Sewerage Structures',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Utilities',
    value: 'Sanitary Sewerage Utilities',
    trade: {
      trade: 'Sanitary Sewerage Utilities',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Sanitary Sewerage Utility Connection',
    value: 'Sanitary Sewerage Utility Connection',
    trade: {
      trade: 'Sanitary Sewerage Utility Connection',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Security Equipment',
    value: 'Security Equipment',
    trade: { trade: 'Security Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Seismic Control',
    value: 'Seismic Control',
    trade: {
      trade: 'Seismic Control',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Seismic Control',
    value: 'Seismic Control',
    trade: { trade: 'Seismic Control', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Seismic Instrumentation',
    value: 'Seismic Instrumentation',
    trade: {
      trade: 'Seismic Instrumentation',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Selective Bridge Demolition',
    value: 'Selective Bridge Demolition',
    trade: {
      trade: 'Selective Bridge Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Selective Building Demolition',
    value: 'Selective Building Demolition',
    trade: {
      trade: 'Selective Building Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Selective Demolition',
    value: 'Selective Demolition',
    trade: {
      trade: 'Selective Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Selective Historic Demolition',
    value: 'Selective Historic Demolition',
    trade: {
      trade: 'Selective Historic Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Selective Interior Demolition',
    value: 'Selective Interior Demolition',
    trade: {
      trade: 'Selective Interior Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Selective Site Demolition',
    value: 'Selective Site Demolition',
    trade: {
      trade: 'Selective Site Demolition',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Septic Tank Services and Sewer Pipe Cleaning',
    value: 'Septic Tank Services and Sewer Pipe Cleaning',
    trade: {
      trade: 'Septic Tank Services and Sewer Pipe Cleaning',
      category: 'Garbage',
      sortOrder: 0
    }
  },
  {
    label: 'Service Tunnels',
    value: 'Service Tunnels',
    trade: {
      trade: 'Service Tunnels',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Service Walls',
    value: 'Service Walls',
    trade: {
      trade: 'Service Walls',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Sewer Utility',
    value: 'Sewer Utility',
    trade: { trade: 'Sewer Utility', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Sewerage / Ecological Toilets / Portalets',
    value: 'Sewerage / Ecological Toilets / Portalets',
    trade: {
      trade: 'Sewerage / Ecological Toilets / Portalets',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Sheet Metal Working (tin knocker)',
    value: 'Sheet Metal Working (tin knocker)',
    trade: {
      trade: 'Sheet Metal Working (tin knocker)',
      category: 'Sheet Metal',
      sortOrder: 0
    }
  },
  {
    label: 'Sheet Metal Working Contracting',
    value: 'Sheet Metal Working Contracting',
    trade: {
      trade: 'Sheet Metal Working Contracting',
      category: 'Sheet Metal',
      sortOrder: 0
    }
  },
  {
    label: 'Shell',
    value: 'Shell',
    trade: { trade: 'Shell', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Shoring',
    value: 'Shoring',
    trade: { trade: 'Shoring', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Sinkhole Remediation',
    value: 'Sinkhole Remediation',
    trade: {
      trade: 'Sinkhole Remediation',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Site Aviation Fuel Distribution',
    value: 'Site Aviation Fuel Distribution',
    trade: {
      trade: 'Site Aviation Fuel Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Bridges',
    value: 'Site Bridges',
    trade: { trade: 'Site Bridges', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Site Clearing',
    value: 'Site Clearing',
    trade: { trade: 'Site Clearing', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Site Communications',
    value: 'Site Communications',
    trade: {
      trade: 'Site Communications',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Site Communications Distribution',
    value: 'Site Communications Distribution',
    trade: {
      trade: 'Site Communications Distribution',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Site Communications Structures',
    value: 'Site Communications Structures',
    trade: {
      trade: 'Site Communications Structures',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Site Communications Systems',
    value: 'Site Communications Systems',
    trade: {
      trade: 'Site Communications Systems',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Site Containment',
    value: 'Site Containment',
    trade: { trade: 'Site Containment', category: 'Remediation', sortOrder: 0 }
  },
  {
    label: 'Site Development',
    value: 'Site Development',
    trade: { trade: 'Site Development', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Site Diesel Fuel Distribution',
    value: 'Site Diesel Fuel Distribution',
    trade: {
      trade: 'Site Diesel Fuel Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Domestic Water Distribution',
    value: 'Site Domestic Water Distribution',
    trade: {
      trade: 'Site Domestic Water Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Earthwork',
    value: 'Site Earthwork',
    trade: { trade: 'Site Earthwork', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Site Electric Distribution Systems',
    value: 'Site Electric Distribution Systems',
    trade: {
      trade: 'Site Electric Distribution Systems',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Site Element Relocations',
    value: 'Site Element Relocations',
    trade: {
      trade: 'Site Element Relocations',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Site Elements Demolition',
    value: 'Site Elements Demolition',
    trade: {
      trade: 'Site Elements Demolition',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Site Energy Distribution',
    value: 'Site Energy Distribution',
    trade: {
      trade: 'Site Energy Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Equipment',
    value: 'Site Equipment',
    trade: { trade: 'Site Equipment', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Site Fire Protection Water Distribution',
    value: 'Site Fire Protection Water Distribution',
    trade: {
      trade: 'Site Fire Protection Water Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Fuel Distribution',
    value: 'Site Fuel Distribution',
    trade: {
      trade: 'Site Fuel Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Fuel-Oil Distribution',
    value: 'Site Fuel-Oil Distribution',
    trade: {
      trade: 'Site Fuel-Oil Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Furnishings',
    value: 'Site Furnishings',
    trade: { trade: 'Site Furnishings', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Site Gas Distribution',
    value: 'Site Gas Distribution',
    trade: {
      trade: 'Site Gas Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Gasoline Distribution',
    value: 'Site Gasoline Distribution',
    trade: {
      trade: 'Site Gasoline Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Grounding',
    value: 'Site Grounding',
    trade: { trade: 'Site Grounding', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Site Hydronic Cooling Distribution',
    value: 'Site Hydronic Cooling Distribution',
    trade: {
      trade: 'Site Hydronic Cooling Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Hydronic Heating Distribution',
    value: 'Site Hydronic Heating Distribution',
    trade: {
      trade: 'Site Hydronic Heating Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Improvements',
    value: 'Site Improvements',
    trade: { trade: 'Site Improvements', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Site Irrigation Water Distribution',
    value: 'Site Irrigation Water Distribution',
    trade: {
      trade: 'Site Irrigation Water Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Lighting',
    value: 'Site Lighting',
    trade: { trade: 'Site Lighting', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Site Preparation',
    value: 'Site Preparation',
    trade: { trade: 'Site Preparation', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Site Preparation - Other',
    value: 'Site Preparation - Other',
    trade: {
      trade: 'Site Preparation - Other',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Site Preparation Contracting',
    value: 'Site Preparation Contracting',
    trade: {
      trade: 'Site Preparation Contracting',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Site Remediation',
    value: 'Site Remediation',
    trade: { trade: 'Site Remediation', category: 'Remediation', sortOrder: 0 }
  },
  {
    label: 'Site Screening Devices',
    value: 'Site Screening Devices',
    trade: {
      trade: 'Site Screening Devices',
      category: 'Landscape',
      sortOrder: 0
    }
  },
  {
    label: 'Site Soil Treatment',
    value: 'Site Soil Treatment',
    trade: { trade: 'Site Soil Treatment', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Site Specialties',
    value: 'Site Specialties',
    trade: { trade: 'Site Specialties', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Site Steam Energy Distribution',
    value: 'Site Steam Energy Distribution',
    trade: {
      trade: 'Site Steam Energy Distribution',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Storm Water Drains',
    value: 'Site Storm Water Drains',
    trade: {
      trade: 'Site Storm Water Drains',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Site Subdrainage',
    value: 'Site Subdrainage',
    trade: { trade: 'Site Subdrainage', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Sitework',
    value: 'Sitework',
    trade: { trade: 'Sitework', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Sky Lights',
    value: 'Sky Lights',
    trade: { trade: 'Sky Lights', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Slab Trenches',
    value: 'Slab Trenches',
    trade: {
      trade: 'Slab Trenches',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Slab-On-Grade Supplementary Components',
    value: 'Slab-On-Grade Supplementary Components',
    trade: {
      trade: 'Slab-On-Grade Supplementary Components',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Slabs-On-Grade',
    value: 'Slabs-On-Grade',
    trade: {
      trade: 'Slabs-On-Grade',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Slope Protection',
    value: 'Slope Protection',
    trade: { trade: 'Slope Protection', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Slurry Walls',
    value: 'Slurry Walls',
    trade: {
      trade: 'Slurry Walls',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Snow Melting',
    value: 'Snow Melting',
    trade: { trade: 'Snow Melting', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Soil Reinforcement',
    value: 'Soil Reinforcement',
    trade: { trade: 'Soil Reinforcement', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Soil Stabilization',
    value: 'Soil Stabilization',
    trade: { trade: 'Soil Stabilization', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Soil Treatment',
    value: 'Soil Treatment',
    trade: {
      trade: 'Soil Treatment',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Solar Photovoltaic Service',
    value: 'Solar Photovoltaic Service',
    trade: {
      trade: 'Solar Photovoltaic Service',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Solid Waste Collection',
    value: 'Solid Waste Collection',
    trade: {
      trade: 'Solid Waste Collection',
      category: 'Garbage',
      sortOrder: 0
    }
  },
  {
    label: 'Solid Waste Handling Equipment',
    value: 'Solid Waste Handling Equipment',
    trade: {
      trade: 'Solid Waste Handling Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Sound and Vibration Control',
    value: 'Sound and Vibration Control',
    trade: {
      trade: 'Sound and Vibration Control',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Space Frames',
    value: 'Space Frames',
    trade: {
      trade: 'Space Frames',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Construction',
    value: 'Special Construction',
    trade: {
      trade: 'Special Construction',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Construction and Demolition',
    value: 'Special Construction and Demolition',
    trade: {
      trade: 'Special Construction and Demolition',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Facility Components',
    value: 'Special Facility Components',
    trade: {
      trade: 'Special Facility Components',
      category: 'Recreational',
      sortOrder: 0
    }
  },
  {
    label: 'Special Foundation Walls',
    value: 'Special Foundation Walls',
    trade: {
      trade: 'Special Foundation Walls',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Special Foundations',
    value: 'Special Foundations',
    trade: {
      trade: 'Special Foundations',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Special Function Construction',
    value: 'Special Function Construction',
    trade: {
      trade: 'Special Function Construction',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Function Suspended Ceilings',
    value: 'Special Function Suspended Ceilings',
    trade: {
      trade: 'Special Function Suspended Ceilings',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Instrumentation',
    value: 'Special Instrumentation',
    trade: {
      trade: 'Special Instrumentation',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Purpose HVAC Systems',
    value: 'Special Purpose HVAC Systems',
    trade: {
      trade: 'Special Purpose HVAC Systems',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Special Structures',
    value: 'Special Structures',
    trade: {
      trade: 'Special Structures',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Special Wall Surfacing',
    value: 'Special Wall Surfacing',
    trade: {
      trade: 'Special Wall Surfacing',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Specialty Flooring',
    value: 'Specialty Flooring',
    trade: {
      trade: 'Specialty Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Specialty Suspended Ceilings',
    value: 'Specialty Suspended Ceilings',
    trade: {
      trade: 'Specialty Suspended Ceilings',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Stair Construction',
    value: 'Stair Construction',
    trade: { trade: 'Stair Construction', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Stair Finishes',
    value: 'Stair Finishes',
    trade: { trade: 'Stair Finishes', category: 'Floors Stairs', sortOrder: 0 }
  },
  {
    label: 'Stair Railings',
    value: 'Stair Railings',
    trade: { trade: 'Stair Railings', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Stair Soffits',
    value: 'Stair Soffits',
    trade: { trade: 'Stair Soffits', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Stairs',
    value: 'Stairs',
    trade: { trade: 'Stairs', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Standard Foundation Supplementary Components',
    value: 'Standard Foundation Supplementary Components',
    trade: {
      trade: 'Standard Foundation Supplementary Components',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Standard Foundations',
    value: 'Standard Foundations',
    trade: {
      trade: 'Standard Foundations',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Standard Slabs-on-Grade',
    value: 'Standard Slabs-on-Grade',
    trade: {
      trade: 'Standard Slabs-on-Grade',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Steep Slope Roofing',
    value: 'Steep Slope Roofing',
    trade: { trade: 'Steep Slope Roofing', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Stone Facing',
    value: 'Stone Facing',
    trade: { trade: 'Stone Facing', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Stone Siding',
    value: 'Stone Siding',
    trade: { trade: 'Stone Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Storage Specialties',
    value: 'Storage Specialties',
    trade: {
      trade: 'Storage Specialties',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Storm Drainage Piping',
    value: 'Storm Drainage Piping',
    trade: {
      trade: 'Storm Drainage Piping',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Storm Drainage Ponds and Reservoirs',
    value: 'Storm Drainage Ponds and Reservoirs',
    trade: {
      trade: 'Storm Drainage Ponds and Reservoirs',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Storm Drainage Pumps',
    value: 'Storm Drainage Pumps',
    trade: {
      trade: 'Storm Drainage Pumps',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Storm Drainage Utilities',
    value: 'Storm Drainage Utilities',
    trade: {
      trade: 'Storm Drainage Utilities',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Storm Drainage Utility Connection',
    value: 'Storm Drainage Utility Connection',
    trade: {
      trade: 'Storm Drainage Utility Connection',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Stormwater Drainage Equipment',
    value: 'Stormwater Drainage Equipment',
    trade: {
      trade: 'Stormwater Drainage Equipment',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Stormwater Drainage Piping',
    value: 'Stormwater Drainage Piping',
    trade: {
      trade: 'Stormwater Drainage Piping',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Street Sweaping',
    value: 'Street Sweaping',
    trade: { trade: 'Street Sweaping', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Stress Instrumentation',
    value: 'Stress Instrumentation',
    trade: {
      trade: 'Stress Instrumentation',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Structural Slabs-on-Grade',
    value: 'Structural Slabs-on-Grade',
    trade: {
      trade: 'Structural Slabs-on-Grade',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Structure Demolition',
    value: 'Structure Demolition',
    trade: {
      trade: 'Structure Demolition',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Structure Moving',
    value: 'Structure Moving',
    trade: { trade: 'Structure Moving', category: 'Demolition', sortOrder: 0 }
  },
  {
    label: 'Structure Raising',
    value: 'Structure Raising',
    trade: { trade: 'Structure Raising', category: 'Demolition', sortOrder: 0 }
  },
  {
    label: 'Structure Relocation',
    value: 'Structure Relocation',
    trade: {
      trade: 'Structure Relocation',
      category: 'Demolition',
      sortOrder: 0
    }
  },
  {
    label: 'Stucco Siding',
    value: 'Stucco Siding',
    trade: { trade: 'Stucco Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Subbase Layer',
    value: 'Subbase Layer',
    trade: {
      trade: 'Subbase Layer',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Subgrade Enclosure Wall Construction',
    value: 'Subgrade Enclosure Wall Construction',
    trade: {
      trade: 'Subgrade Enclosure Wall Construction',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Subgrade Enclosure Wall Interior Skin',
    value: 'Subgrade Enclosure Wall Interior Skin',
    trade: {
      trade: 'Subgrade Enclosure Wall Interior Skin',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Subgrade Enclosure Wall Supplementary Components',
    value: 'Subgrade Enclosure Wall Supplementary Components',
    trade: {
      trade: 'Subgrade Enclosure Wall Supplementary Components',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Subgrade Enclosures',
    value: 'Subgrade Enclosures',
    trade: {
      trade: 'Subgrade Enclosures',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Substructure',
    value: 'Substructure',
    trade: {
      trade: 'Substructure',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Substructure Excavation',
    value: 'Substructure Excavation',
    trade: {
      trade: 'Substructure Excavation',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Substructure Related Activities',
    value: 'Substructure Related Activities',
    trade: {
      trade: 'Substructure Related Activities',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Superstructure',
    value: 'Superstructure',
    trade: { trade: 'Superstructure', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Supplementary Components',
    value: 'Supplementary Components',
    trade: {
      trade: 'Supplementary Components',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Supplementary Components',
    value: 'Supplementary Components',
    trade: {
      trade: 'Supplementary Components',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Supplementary Components',
    value: 'Supplementary Components',
    trade: {
      trade: 'Supplementary Components',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Supply Air',
    value: 'Supply Air',
    trade: { trade: 'Supply Air', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Supply Services',
    value: 'Supply Services',
    trade: { trade: 'Supply Services', category: 'Supplier', sortOrder: 0 }
  },
  {
    label: 'Suspended Ceiling Construction',
    value: 'Suspended Ceiling Construction',
    trade: {
      trade: 'Suspended Ceiling Construction',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Suspended Plaster and Gypsum Board Ceilings',
    value: 'Suspended Plaster and Gypsum Board Ceilings',
    trade: {
      trade: 'Suspended Plaster and Gypsum Board Ceilings',
      category: 'Interior Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Suspended Scaffolding',
    value: 'Suspended Scaffolding',
    trade: {
      trade: 'Suspended Scaffolding',
      category: 'Scaffolding',
      sortOrder: 0
    }
  },
  {
    label: 'Tape Only',
    value: 'Tape Only',
    trade: { trade: 'Tape Only', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Teller and Service Equipment',
    value: 'Teller and Service Equipment',
    trade: {
      trade: 'Teller and Service Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Temporary Electric Service',
    value: 'Temporary Electric Service',
    trade: {
      trade: 'Temporary Electric Service',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Temporary Utilities',
    value: 'Temporary Utilities',
    trade: { trade: 'Temporary Utilities', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Temporary Water Service',
    value: 'Temporary Water Service',
    trade: {
      trade: 'Temporary Water Service',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Terrazzo Flooring',
    value: 'Terrazzo Flooring',
    trade: {
      trade: 'Terrazzo Flooring',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Terrazzo Stair Finish',
    value: 'Terrazzo Stair Finish',
    trade: {
      trade: 'Terrazzo Stair Finish',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  },
  {
    label: 'Theater and Stage Equipment',
    value: 'Theater and Stage Equipment',
    trade: {
      trade: 'Theater and Stage Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Thermal Cooling Storage',
    value: 'Thermal Cooling Storage',
    trade: { trade: 'Thermal Cooling Storage', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Thermal Decontamination',
    value: 'Thermal Decontamination',
    trade: {
      trade: 'Thermal Decontamination',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Thermal Heat Storage',
    value: 'Thermal Heat Storage',
    trade: { trade: 'Thermal Heat Storage', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Tile\tTile Flooring',
    value: 'Tile\tTile Flooring',
    trade: { trade: 'Tile\tTile Flooring', category: 'Supplier', sortOrder: 0 }
  },
  {
    label: 'Tile Stair Finish',
    value: 'Tile Stair Finish',
    trade: { trade: 'Tile Stair Finish', category: 'Supplier', sortOrder: 0 }
  },
  {
    label: 'Tile Wall Finish',
    value: 'Tile Wall Finish',
    trade: { trade: 'Tile Wall Finish', category: 'Supplier', sortOrder: 0 }
  },
  {
    label: 'Tile Wall Finish',
    value: 'Tile Wall Finish',
    trade: { trade: 'Tile Wall Finish', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Toilet, Bath, and Laundry Accessories',
    value: 'Toilet, Bath, and Laundry Accessories',
    trade: {
      trade: 'Toilet, Bath, and Laundry Accessories',
      category: 'Plumbing',
      sortOrder: 0
    }
  },
  {
    label: 'Tower Demolition',
    value: 'Tower Demolition',
    trade: { trade: 'Tower Demolition', category: 'Demolition', sortOrder: 0 }
  },
  {
    label: 'Towers',
    value: 'Towers',
    trade: { trade: 'Towers', category: 'Special Construction', sortOrder: 0 }
  },
  {
    label: 'Traffic Bearing Coatings',
    value: 'Traffic Bearing Coatings',
    trade: { trade: 'Traffic Bearing Coatings', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Traffic Bearing Horizontal Enclosures',
    value: 'Traffic Bearing Horizontal Enclosures',
    trade: {
      trade: 'Traffic Bearing Horizontal Enclosures',
      category: 'Roof',
      sortOrder: 0
    }
  },
  {
    label: 'Transfer Switches',
    value: 'Transfer Switches',
    trade: { trade: 'Transfer Switches', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Transient Voltage Suppression',
    value: 'Transient Voltage Suppression',
    trade: {
      trade: 'Transient Voltage Suppression',
      category: 'Electric',
      sortOrder: 0
    }
  },
  {
    label: 'Transportation and Disposal of Hazardous Materials',
    value: 'Transportation and Disposal of Hazardous Materials',
    trade: {
      trade: 'Transportation and Disposal of Hazardous Materials',
      category: 'Remediation',
      sortOrder: 0
    }
  },
  {
    label: 'Tree and Shrub Removal and Trimming',
    value: 'Tree and Shrub Removal and Trimming',
    trade: {
      trade: 'Tree and Shrub Removal and Trimming',
      category: 'Site Prep',
      sortOrder: 0
    }
  },
  {
    label: 'Trim Painting',
    value: 'Trim Painting',
    trade: { trade: 'Trim Painting', category: 'Paint', sortOrder: 0 }
  },
  {
    label: 'Trusses',
    value: 'Trusses',
    trade: { trade: 'Trusses', category: 'Structure', sortOrder: 0 }
  },
  {
    label: 'Tunnel Construction Related Activities',
    value: 'Tunnel Construction Related Activities',
    trade: {
      trade: 'Tunnel Construction Related Activities',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Tunnels',
    value: 'Tunnels',
    trade: { trade: 'Tunnels', category: 'Special Construction', sortOrder: 0 }
  },
  {
    label: 'Turf and Grasses',
    value: 'Turf and Grasses',
    trade: { trade: 'Turf and Grasses', category: 'Landscape', sortOrder: 0 }
  },
  {
    label: 'Turntables',
    value: 'Turntables',
    trade: { trade: 'Turntables', category: 'Conveying', sortOrder: 0 }
  },
  {
    label: 'Underground Utility Services',
    value: 'Underground Utility Services',
    trade: {
      trade: 'Underground Utility Services',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Underpinning',
    value: 'Underpinning',
    trade: {
      trade: 'Underpinning',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Underslab Drainage',
    value: 'Underslab Drainage',
    trade: {
      trade: 'Underslab Drainage',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Unit Kitchens',
    value: 'Unit Kitchens',
    trade: { trade: 'Unit Kitchens', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Utility Demolition',
    value: 'Utility Demolition',
    trade: { trade: 'Utility Demolition', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Utility Relocation',
    value: 'Utility Relocation',
    trade: { trade: 'Utility Relocation', category: 'Site Prep', sortOrder: 0 }
  },
  {
    label: 'Utility Septic Tanks',
    value: 'Utility Septic Tanks',
    trade: {
      trade: 'Utility Septic Tanks',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Utility Services',
    value: 'Utility Services',
    trade: { trade: 'Utility Services', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Vacuum Systems',
    value: 'Vacuum Systems',
    trade: { trade: 'Vacuum Systems', category: 'Plumbing', sortOrder: 0 }
  },
  {
    label: 'Vapor Retarder',
    value: 'Vapor Retarder',
    trade: {
      trade: 'Vapor Retarder',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Vault Equipment',
    value: 'Vault Equipment',
    trade: { trade: 'Vault Equipment', category: 'Equipment', sortOrder: 0 }
  },
  {
    label: 'Vehicle Fare Collection',
    value: 'Vehicle Fare Collection',
    trade: {
      trade: 'Vehicle Fare Collection',
      category: 'Roadway',
      sortOrder: 0
    }
  },
  {
    label: 'Vehicle Servicing Equipment',
    value: 'Vehicle Servicing Equipment',
    trade: {
      trade: 'Vehicle Servicing Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Vehicle and Pedestrian Equipment',
    value: 'Vehicle and Pedestrian Equipment',
    trade: {
      trade: 'Vehicle and Pedestrian Equipment',
      category: 'Equipment',
      sortOrder: 0
    }
  },
  {
    label: 'Vehicular Tunnels',
    value: 'Vehicular Tunnels',
    trade: {
      trade: 'Vehicular Tunnels',
      category: 'Special Construction',
      sortOrder: 0
    }
  },
  {
    label: 'Ventilation',
    value: 'Ventilation',
    trade: { trade: 'Ventilation', category: 'HVAC', sortOrder: 0 }
  },
  {
    label: 'Ventilation Supplementary Components',
    value: 'Ventilation Supplementary Components',
    trade: {
      trade: 'Ventilation Supplementary Components',
      category: 'HVAC',
      sortOrder: 0
    }
  },
  {
    label: 'Vents and Hatches',
    value: 'Vents and Hatches',
    trade: { trade: 'Vents and Hatches', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Vertical Conveying Systems',
    value: 'Vertical Conveying Systems',
    trade: {
      trade: 'Vertical Conveying Systems',
      category: 'Conveying',
      sortOrder: 0
    }
  },
  {
    label: 'Video Surveillance',
    value: 'Video Surveillance',
    trade: {
      trade: 'Video Surveillance',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Vinyl Siding',
    value: 'Vinyl Siding',
    trade: { trade: 'Vinyl Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Voice Communications',
    value: 'Voice Communications',
    trade: {
      trade: 'Voice Communications',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Voice Communications Messaging',
    value: 'Voice Communications Messaging',
    trade: {
      trade: 'Voice Communications Messaging',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Voice Communications Switching and Routing Equipment',
    value: 'Voice Communications Switching and Routing Equipment',
    trade: {
      trade: 'Voice Communications Switching and Routing Equipment',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Voice Communications Terminal Equipment',
    value: 'Voice Communications Terminal Equipment',
    trade: {
      trade: 'Voice Communications Terminal Equipment',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Wall Carpeting',
    value: 'Wall Carpeting',
    trade: { trade: 'Wall Carpeting', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Wall Coverings',
    value: 'Wall Coverings',
    trade: { trade: 'Wall Coverings', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Wall Finish Supplementary Components',
    value: 'Wall Finish Supplementary Components',
    trade: {
      trade: 'Wall Finish Supplementary Components',
      category: 'Ceiling Wall',
      sortOrder: 0
    }
  },
  {
    label: 'Wall Finishes',
    value: 'Wall Finishes',
    trade: { trade: 'Wall Finishes', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Wall Foundations',
    value: 'Wall Foundations',
    trade: {
      trade: 'Wall Foundations',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Wall Painting and Coating',
    value: 'Wall Painting and Coating',
    trade: {
      trade: 'Wall Painting and Coating',
      category: 'Paint',
      sortOrder: 0
    }
  },
  {
    label: 'Wall Paneling',
    value: 'Wall Paneling',
    trade: { trade: 'Wall Paneling', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Wall and Door Protection',
    value: 'Wall and Door Protection',
    trade: {
      trade: 'Wall and Door Protection',
      category: 'Special Interior',
      sortOrder: 0
    }
  },
  {
    label: 'Walls for Subgrade Enclosures',
    value: 'Walls for Subgrade Enclosures',
    trade: {
      trade: 'Walls for Subgrade Enclosures',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Waste Management',
    value: 'Waste Management',
    trade: { trade: 'Waste Management', category: 'Garbage', sortOrder: 0 }
  },
  {
    label: 'Waste Management - Waste Collection - Dumpster',
    value: 'Waste Management - Waste Collection - Dumpster',
    trade: {
      trade: 'Waste Management - Waste Collection - Dumpster',
      category: 'Garbage',
      sortOrder: 0
    }
  },
  {
    label: 'Waste Management Services',
    value: 'Waste Management Services',
    trade: {
      trade: 'Waste Management Services',
      category: 'Garbage',
      sortOrder: 0
    }
  },
  {
    label: 'Water Intrusion Detection and Alarm',
    value: 'Water Intrusion Detection and Alarm',
    trade: {
      trade: 'Water Intrusion Detection and Alarm',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Water Remediation',
    value: 'Water Remediation',
    trade: { trade: 'Water Remediation', category: 'Remediation', sortOrder: 0 }
  },
  {
    label: 'Water Utilities',
    value: 'Water Utilities',
    trade: { trade: 'Water Utilities', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Water Utility',
    value: 'Water Utility',
    trade: { trade: 'Water Utility', category: 'Utilities', sortOrder: 0 }
  },
  {
    label: 'Water and Gas Mitigation',
    value: 'Water and Gas Mitigation',
    trade: {
      trade: 'Water and Gas Mitigation',
      category: 'Substructure Mitigation',
      sortOrder: 0
    }
  },
  {
    label: 'Water-Based Fire-Suppression',
    value: 'Water-Based Fire-Suppression',
    trade: {
      trade: 'Water-Based Fire-Suppression',
      category: 'Detection Alarm',
      sortOrder: 0
    }
  },
  {
    label: 'Waterproofing',
    value: 'Waterproofing',
    trade: {
      trade: 'Waterproofing',
      category: 'Foundation Substructure',
      sortOrder: 0
    }
  },
  {
    label: 'Wear Surfaces',
    value: 'Wear Surfaces',
    trade: { trade: 'Wear Surfaces', category: 'Roof', sortOrder: 0 }
  },
  {
    label: 'Wetlands',
    value: 'Wetlands',
    trade: { trade: 'Wetlands', category: 'Earthwork', sortOrder: 0 }
  },
  {
    label: 'Wind Turbine Service',
    value: 'Wind Turbine Service',
    trade: {
      trade: 'Wind Turbine Service',
      category: 'Utilities',
      sortOrder: 0
    }
  },
  {
    label: 'Window Treatments',
    value: 'Window Treatments',
    trade: { trade: 'Window Treatments', category: 'Furnishings', sortOrder: 0 }
  },
  {
    label: 'Windows',
    value: 'Windows',
    trade: { trade: 'Windows', category: 'Glass', sortOrder: 0 }
  },
  {
    label: 'Windows, Glass, and Glazing Contracting',
    value: 'Windows, Glass, and Glazing Contracting',
    trade: {
      trade: 'Windows, Glass, and Glazing Contracting',
      category: 'Glass',
      sortOrder: 0
    }
  },
  {
    label: 'Wireless Communications Distribution',
    value: 'Wireless Communications Distribution',
    trade: {
      trade: 'Wireless Communications Distribution',
      category: 'Communications',
      sortOrder: 0
    }
  },
  {
    label: 'Wiring Devices',
    value: 'Wiring Devices',
    trade: { trade: 'Wiring Devices', category: 'Electric', sortOrder: 0 }
  },
  {
    label: 'Wood Flooring',
    value: 'Wood Flooring',
    trade: { trade: 'Wood Flooring', category: 'Floors Stairs', sortOrder: 0 }
  },
  {
    label: 'Wood Paneling',
    value: 'Wood Paneling',
    trade: { trade: 'Wood Paneling', category: 'Ceiling Wall', sortOrder: 0 }
  },
  {
    label: 'Wood Siding',
    value: 'Wood Siding',
    trade: { trade: 'Wood Siding', category: 'Siding', sortOrder: 0 }
  },
  {
    label: 'Wood Stair Finish',
    value: 'Wood Stair Finish',
    trade: {
      trade: 'Wood Stair Finish',
      category: 'Floors Stairs',
      sortOrder: 0
    }
  }
];

export default TradeListOptions;
